"use strict";

require("core-js/modules/es6.regexp.search");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.array.find-index");

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.object.create");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.some");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

function e(e) {
  return e && "object" == typeof e && "default" in e ? e["default"] : e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var t = require("react"),
    r = e(t),
    n = require("slate-react"),
    o = require("react-icons/fa"),
    a = e(require("is-hotkey")),
    i = require("react-dropzone"),
    l = e(require("react-loader-spinner")),
    c = e(require("classnames")),
    s = e(require("cogo-toast")),
    u = e(require("isomorphic-unfetch")),
    d = require("slate"),
    p = e(require("slate-plain-serializer")),
    m = require("react-icons/fi"),
    g = e(require("react-dom")),
    f = require("uuid"),
    b = require("react-icons/ai"),
    y = e(require("react-copy-to-clipboard")),
    h = require("riec"),
    x = e(h),
    v = require("react-hook-form"),
    k = t.createContext({
  isAdmin: !1,
  user: null,
  setUser: function setUser() {},
  currentPage: "",
  setCurrentPage: function setCurrentPage() {},
  previewMode: !1,
  setPreviewMode: function setPreviewMode() {},
  sidebarCollapsed: !1,
  setSidebarCollapsed: function setSidebarCollapsed() {},
  getStyles: function getStyles() {
    return [];
  },
  getStylesheets: function getStylesheets() {
    return [];
  }
}),
    E = {
  document: {
    nodes: [{
      min: 1,
      max: 1
    }]
  }
};

function w() {
  return (w = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function C(e, t) {
  if (null == e) return {};
  var r,
      n,
      o = {},
      a = Object.keys(e);

  for (n = 0; n < a.length; n++) {
    t.indexOf(r = a[n]) >= 0 || (o[r] = e[r]);
  }

  return o;
}

var N,
    S,
    T,
    L,
    I,
    P,
    B,
    O,
    z,
    A = function A(e, t) {
  return {
    onKeyDown: function onKeyDown(r, n, o) {
      if (!a(t, r)) return o();
      r.preventDefault(), n.toggleMark(e);
    }
  };
},
    j = function j(e, r) {
  return {
    renderMark: function renderMark(n, o, a) {
      return n.mark.type === e ? t.createElement(r, Object.assign({}, n)) : a();
    }
  };
},
    D = function D(e, t) {
  return e.activeMarks.some(function (e) {
    return e.type === t;
  });
},
    F = function F(e) {
  return t.createElement("strong", Object.assign({}, e.attributes), e.children);
},
    R = {
  plugin: function plugin(e) {
    return w({}, A("bold", "mod+b"), j("bold", e.renderBold || F));
  },
  Button: function Button(e) {
    var r = e.editor,
        n = {};
    return D(e.value, "bold") ? (n.color = "#f6e05e", n.backgroundColor = "black") : n.color = "white", t.createElement("button", {
      type: "button",
      style: n,
      onMouseDown: function onMouseDown(e) {
        e.preventDefault(), r && r.current.toggleMark("bold");
      }
    }, t.createElement(o.FaBold, null));
  }
},
    M = function M(e) {
  return t.createElement("em", Object.assign({}, e.attributes), e.children);
},
    q = {
  plugin: function plugin(e) {
    return w({}, A("italic", "mod+i"), j("italic", e.renderItalic || M));
  },
  Button: function Button(e) {
    var r = e.editor,
        n = {};
    return D(e.value, "italic") ? (n.color = "#f6e05e", n.backgroundColor = "black") : n.color = "white", t.createElement("button", {
      type: "button",
      style: n,
      onMouseDown: function onMouseDown(e) {
        e.preventDefault(), r && r.current.toggleMark("italic");
      }
    }, t.createElement(o.FaItalic, null));
  }
},
    U = function U(e) {
  return t.createElement("mark", Object.assign({
    className: "px-1 rounded-sm bg-yellow-300"
  }, e.attributes), e.children);
},
    H = {
  plugin: function plugin(e) {
    return w({}, A("highlight", "mod+shift+1"), j("highlight", e.renderHighlight || U));
  },
  Button: function Button(e) {
    var r = e.editor,
        n = {};
    return D(e.value, "highlight") ? (n.color = "#f6e05e", n.backgroundColor = "black") : n.color = "white", t.createElement("button", {
      type: "button",
      style: n,
      onMouseDown: function onMouseDown(e) {
        e.preventDefault(), r && r.current.toggleMark("highlight");
      }
    }, t.createElement(o.FaHighlighter, null));
  }
},
    W = function W(e) {
  return t.createElement("code", Object.assign({
    className: "bg-gray-200 text-sm py-1 px-2 rounded"
  }, e.attributes), e.children);
},
    Q = {
  plugin: function plugin(e) {
    return w({}, j("code", e.renderCode || W));
  },
  Button: function Button(e) {
    var r = e.editor,
        n = {};
    return D(e.value, "code") ? (n.color = "#f6e05e", n.backgroundColor = "black") : n.color = "white", t.createElement("button", {
      type: "button",
      style: n,
      onMouseDown: function onMouseDown(e) {
        e.preventDefault(), r && r.current.toggleMark("code");
      }
    }, t.createElement(o.FaCode, null));
  }
},
    _ = t.createContext({
  appId: "",
  apiKey: "",
  blockTypeSchema: [],
  pageTypeSchema: [],
  logo: "",
  contentClassName: "",
  renderLocalLink: function renderLocalLink(e) {
    return t.createElement("a", {
      href: e.href
    }, e.children);
  },
  navigate: function navigate() {},
  loginPath: "",
  editorPath: "",
  playgroundPath: "",
  appSettingsPath: ""
}),
    K = function K(e) {
  var r = e.href,
      n = e.children,
      o = e.target,
      a = C(e, ["href", "children", "target"]),
      i = t.useContext(_).renderLocalLink;
  return /^\/(?!\/)/.test(r) ? i ? i(w({
    href: r,
    target: o,
    children: n
  }, a)) : (console.warn("Local path found in Link, but no renderLocalLink function was provided. Rendering <a> as fallback"), t.createElement("a", Object.assign({
    href: r,
    target: o
  }, a), n)) : t.createElement("a", {
    href: r,
    target: o
  }, n);
},
    G = function G(e, t) {
  e.wrapInline({
    type: "link",
    data: {
      href: t
    }
  }), e.moveToEnd();
},
    J = function J(e) {
  e.unwrapInline("link");
},
    V = function V(e) {
  return e.inlines.some(function (e) {
    return "link" === e.type;
  });
},
    X = {
  plugin: function plugin(e) {
    return {
      renderInline: function renderInline(r, n) {
        var o = r.attributes,
            a = r.children,
            i = r.node;

        switch (i.type) {
          case "link":
            var l = i.data.get("href");
            return e.renderLink ? e.renderLink({
              href: l,
              children: a,
              attributes: o
            }) : t.createElement(K, {
              href: l
            }, a);

          default:
            return n();
        }
      }
    };
  },
  Button: function Button(e) {
    var r = e.editor,
        n = e.value,
        a = {};
    return V(n) ? (a.color = "#f6e05e", a.backgroundColor = "black") : a.color = "white", t.createElement("button", {
      type: "button",
      style: a,
      onMouseDown: function onMouseDown(e) {
        if (e.preventDefault(), r) if (V(n)) r.current.command(J);else if (n.selection.isExpanded) {
          var t = window.prompt("Insert link URL");
          if (!t) return;
          r.current.command(G, t);
        }
      }
    }, t.createElement(o.FaLink, null));
  }
},
    Y = {
  plugin: function plugin(e) {
    return {
      renderBlock: function renderBlock(r, n, o) {
        var a = r.attributes,
            i = r.children;

        switch (r.node.type) {
          case "unordered-list":
            return e && e.renderUL ? e.renderUL(r) : t.createElement("ul", Object.assign({}, a), i);

          case "list-item":
            return e && e.renderLI ? e.renderLI(r) : t.createElement("li", Object.assign({}, a), i);

          default:
            return o();
        }
      }
    };
  },
  Button: function Button(e) {
    var r = e.editor,
        n = e.value,
        a = {};
    return function (e) {
      var t = e.blocks;

      if (t.size > 0) {
        var r = e.document.getParent(t.first().key);
        return t.some(function (e) {
          return "list-item" === e.type;
        }) && r && "unordered-list" === r.type;
      }

      return !1;
    }(n) ? (a.color = "#f6e05e", a.backgroundColor = "black") : a.color = "white", t.createElement("button", {
      type: "button",
      style: a,
      onMouseDown: function onMouseDown(e) {
        if (e.preventDefault(), r) {
          var t = n.blocks.some(function (e) {
            return "list-item" === e.type;
          }),
              o = n.blocks.some(function (e) {
            return !!n.document.getClosest(e.key, function (e) {
              return "unordered-list" === e.type;
            });
          });
          t && o ? r.current.setBlocks("paragraph").unwrapBlock("unordered-list") : t ? r.current.unwrapBlock("ordered-list").wrapBlock("unordered-list") : r.current.setBlocks("list-item").wrapBlock("unordered-list");
        }
      }
    }, t.createElement(o.FaListUl, null));
  }
},
    $ = {
  plugin: function plugin(e) {
    return {
      renderBlock: function renderBlock(r, n, o) {
        var a = r.attributes,
            i = r.children;

        switch (r.node.type) {
          case "ordered-list":
            return e && e.renderOL ? e.renderOL(r) : t.createElement("ol", Object.assign({}, a), i);

          case "list-item":
            return e && e.renderLI ? e.renderLI(r) : t.createElement("li", Object.assign({}, a), i);

          default:
            return o();
        }
      }
    };
  },
  Button: function Button(e) {
    var r = e.editor,
        n = e.value,
        a = {};
    return function (e) {
      var t = e.blocks;

      if (t.size > 0) {
        var r = e.document.getParent(t.first().key);
        return t.some(function (e) {
          return "list-item" === e.type;
        }) && r && "ordered-list" === r.type;
      }

      return !1;
    }(n) ? (a.color = "#f6e05e", a.backgroundColor = "black") : a.color = "white", t.createElement("button", {
      type: "button",
      style: a,
      onMouseDown: function onMouseDown(e) {
        if (e.preventDefault(), r) {
          var t = n.blocks.some(function (e) {
            return "list-item" === e.type;
          }),
              o = n.blocks.some(function (e) {
            return !!n.document.getClosest(e.key, function (e) {
              return "ordered-list" === e.type;
            });
          });
          t && o ? r.current.setBlocks("paragraph").unwrapBlock("ordered-list") : t ? r.current.unwrapBlock("unordered-list").wrapBlock("ordered-list") : r.current.setBlocks("list-item").wrapBlock("ordered-list");
        }
      }
    }, t.createElement(o.FaListOl, null));
  }
};

(B = (O = exports.types || (exports.types = {})).BlockSuperType || (O.BlockSuperType = {})).Single = "SINGLE", B.Repeater = "REPEATER", (P = O.SideEditPropType || (O.SideEditPropType = {})).Text = "TEXT", P.Number = "NUMBER", P.Date = "DATE", P.Range = "RANGE", P.Boolean = "BOOLEAN", P.Select = "SELECT", P.Image = "IMAGE", (I = O.RichTextFeatures || (O.RichTextFeatures = {})).Bold = "BOLD", I.Italic = "ITALIC", I.Code = "CODE", I.Highlight = "HIGHLIGHT", I.Link = "LINK", I.UnorderedList = "UL", I.OrderedList = "OL", (L = O.SortDirection || (O.SortDirection = {})).Up = "UP", L.Down = "DOWN", (T = O.OptionsDisplay || (O.OptionsDisplay = {})).Select = "SELECT", T.Radio = "RADIO", T.Color = "COLOR", (S = O.PageStatus || (O.PageStatus = {})).Draft = "DRAFT", S.Published = "PUBLISHED", (N = O.PlaygroundSelectedItemType || (O.PlaygroundSelectedItemType = {})).Block = "BLOCK", N.Page = "PAGE";

var Z = ((z = {})[exports.types.RichTextFeatures.Bold] = R, z[exports.types.RichTextFeatures.Italic] = q, z[exports.types.RichTextFeatures.Highlight] = H, z[exports.types.RichTextFeatures.Code] = Q, z[exports.types.RichTextFeatures.Link] = X, z[exports.types.RichTextFeatures.UnorderedList] = Y, z[exports.types.RichTextFeatures.OrderedList] = $, z),
    ee = function ee(e) {
  var r = e.value,
      n = e.allowedFeatures,
      o = void 0 === n ? [] : n,
      a = e.rtRef,
      i = e.editorRef;
  if (r.selection.isBlurred || r.selection.isCollapsed) return null;
  var l = document.getElementById("rb-admin-frame"),
      c = l && l.contentWindow && l.contentWindow.document.getElementById("rb-content-frame"),
      s = c && c.contentWindow ? c.contentWindow.getSelection() : null;
  if (!s) return null;
  if (0 === (null == s ? void 0 : s.rangeCount)) return null;
  var u = s ? s.getRangeAt(0) : null,
      d = u ? u.getBoundingClientRect() : null;
  if (!d) return null;
  var p = a.current.getBoundingClientRect(),
      m = o.length;
  return t.createElement("div", null, t.createElement("style", null, "\n.toolbar {\n  display: flex;\n  background-color: #1a202c;\n  overflow: hidden;\n  font-size: 0.875rem;\n  border-radius: 0.25rem;\n}\n\n.toolbar button {\n  font-family: inherit;\n  font-size: 100%;\n  line-height: 1.15;\n  margin: 0;\n  overflow: visible;\n  -webkit-appearance: button;\n  padding: 0;\n  line-height: inherit;\n  color: inherit;\n  cursor: pointer;\n  border: none;\n  background-color: transparent;\n}\n.toolbar button:focus {\n  outline: 1px dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n}\n.toolbar button {\n  padding: 0.75rem;\n}"), t.createElement("div", {
    className: "toolbar",
    style: {
      position: "absolute",
      top: d.top - p.top - 42,
      left: d.left - p.left + d.width / 2 - 19 * m
    }
  }, o.map(function (e) {
    return t.createElement(Z[e].Button, {
      key: e,
      editor: i,
      value: r
    });
  })));
},
    te = function te(e) {
  var r = e.renderBlock,
      o = e.value,
      a = e.placeholder,
      i = e.allowedFeatures,
      l = void 0 === i ? [] : i,
      c = e.renderBold,
      s = e.renderItalic,
      u = e.renderHighlight,
      d = e.renderCode,
      p = e.renderLink,
      m = e.renderUL,
      g = e.renderOL,
      f = e.renderLI,
      b = e.propName,
      y = e.onChange,
      h = t.useRef(null),
      x = t.useRef(null),
      v = t.useContext(k),
      E = v.previewMode || !v.isAdmin,
      w = {
    renderBold: c,
    renderItalic: s,
    renderHighlight: u,
    renderCode: d,
    renderLink: p,
    renderUL: m,
    renderOL: g,
    renderLI: f
  },
      C = l.map(function (e) {
    return Z[e].plugin(w);
  });
  C.push({
    renderBlock: function renderBlock(e, t, n) {
      return -1 === e.node.type.indexOf("list") ? r(e) : n();
    }
  });
  var N = t.useState(C)[0];
  return E ? t.createElement(n.Editor, {
    readOnly: !0,
    ref: x,
    plugins: N,
    value: o
  }) : t.createElement("div", {
    ref: h,
    style: {
      position: "relative"
    }
  }, o.selection.isFocused && o.selection.isExpanded && t.createElement(ee, {
    value: o,
    allowedFeatures: l,
    rtRef: h,
    editorRef: x
  }), t.createElement(n.Editor, {
    ref: x,
    plugins: N,
    placeholder: a,
    value: o,
    onChange: function onChange(e) {
      y(b, e.value);
    }
  }));
},
    re = "https://api.reactbricks.com/v1/admin",
    ne = "react-bricks-token",
    oe = "https://api.reactbricks.com/v1/app",
    ae = function ae(e, t) {
  try {
    return Promise.resolve(u(e, t)).then(function (e) {
      return "DELETE" === t.method ? e : Promise.resolve(e.json());
    });
  } catch (e) {
    return Promise.reject(e);
  }
},
    ie = require("react-query").useMutation,
    le = require("react-progressive-graceful-image")["default"],
    ce = function ce(e) {
  var r = e.source,
      n = e.alt,
      o = e.maxWidth,
      a = e.noLazyLoad,
      u = void 0 !== a && a,
      d = e.propName,
      p = e.onChange,
      m = e.containerClassName,
      g = e.imageClassName,
      f = C(e, ["source", "alt", "maxWidth", "noLazyLoad", "propName", "onChange", "containerClassName", "imageClassName"]),
      b = t.useState(!1),
      y = b[0],
      h = b[1],
      x = t.useContext(k),
      v = x.currentPage,
      E = x.previewMode || !x.isAdmin,
      w = ie(function (e) {
    var t = e.formData;
    return ae(re + "/images", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(ne)
      },
      body: t
    });
  }, {
    onSuccess: function onSuccess(e) {
      423 === e.statusCode ? s.warn("Saving not allowed on this demo", {
        position: "bottom-right"
      }) : e.statusCode && s.error("An error occurred while uploading", {
        position: "bottom-right"
      });
    },
    onError: function onError() {
      s.error("An error occurred while uploading", {
        position: "bottom-right"
      });
    }
  })[0],
      N = i.useDropzone({
    onDrop: function onDrop(e) {
      try {
        var t = new FormData();
        return t.append("file", e[0]), v && -1 === v.indexOf("playground") && t.append("pageId", v), o && t.append("maxWidth", o + ""), h(!0), Promise.resolve(w({
          formData: t
        })).then(function (e) {
          p(d, {
            src: e.src,
            placeholderSrc: e.placeholderSrc,
            srcSet: e.srcSet
          }), h(!1);
        });
      } catch (e) {
        return Promise.reject(e);
      }
    }
  }),
      S = N.getRootProps,
      T = N.getInputProps;
  return E ? r ? u ? t.createElement("img", Object.assign({
    src: r.src,
    srcSet: r.srcSet,
    alt: n,
    className: g
  }, f)) : t.createElement(le, {
    src: r.src,
    srcSetData: {
      srcSet: r.srcSet
    },
    placeholder: ""
  }, function (e, o, a) {
    return t.createElement("img", o ? {
      src: r.placeholderSrc,
      alt: n,
      className: g,
      style: {
        filter: "blur(8px)"
      }
    } : Object.assign({
      src: e,
      srcSet: a.srcSet,
      alt: n,
      className: g
    }, f));
  }) : null : t.createElement("div", {
    className: c("react-bricks-image", m),
    style: {
      position: "relative"
    }
  }, t.createElement("style", null, "\n.react-bricks-image .overlay-container {\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10;\n  transition: 'opacity 300ms';\n}\n\n.react-bricks-image .overlay-container:hover {\n  opacity: 1;\n}\n\n.react-bricks-image .overlay-container .upload {\n  background-color: rgba(255, 255, 255, 0.8);\n  padding: 0.75rem;\n  border-radius: 9999px;\n  cursor: pointer;\n  border: 1px solid #edf2f7;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),\n    0 2px 4px -1px rgba(0, 0, 0, 0.06);\n}\n\n.react-bricks-image .overlay-container .upload svg {\n  width: 32px;\n  fill: #d9367f;\n}\n\n.react-bricks-image .loading {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #fff;\n  opacity: 0.75;\n  z-index: 50;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n"), r ? t.createElement("img", {
    src: r.src,
    alt: n,
    className: g
  }) : t.createElement("div", {
    style: {
      minHeight: 80,
      backgroundColor: "#edf2f7"
    }
  }), t.createElement("div", {
    className: "overlay-container"
  }, t.createElement("div", Object.assign({}, S()), t.createElement("div", {
    className: "upload"
  }, t.createElement("svg", {
    viewBox: "0 0 312.602 312.602"
  }, t.createElement("path", {
    d: "M251.52,137.244c-3.966,0-7.889,0.38-11.738,1.134c-1.756-47.268-40.758-85.181-88.448-85.181c-43.856,0-80.964,32.449-87.474,75.106C28.501,129.167,0,158.201,0,193.764c0,36.106,29.374,65.48,65.48,65.48h54.782c4.143,0,7.5-3.357,7.5-7.5c0-4.143-3.357-7.5-7.5-7.5H65.48c-27.835,0-50.48-22.645-50.48-50.48c0-27.835,22.646-50.48,50.48-50.48c1.367,0,2.813,0.067,4.419,0.206l7.6,0.658l0.529-7.61c2.661-38.322,34.861-68.341,73.306-68.341c40.533,0,73.51,32.977,73.51,73.51c0,1.863-0.089,3.855-0.272,6.088l-0.983,11.968l11.186-4.367c5.356-2.091,10.99-3.151,16.747-3.151c25.409,0,46.081,20.672,46.081,46.081c0,25.408-20.672,46.08-46.081,46.08c-0.668,0-20.608-0.04-40.467-0.08c-19.714-0.04-39.347-0.08-39.999-0.08c-4.668,0-7.108-2.248-7.254-6.681v-80.959l8.139,9.667c2.667,3.17,7.399,3.576,10.567,0.907c3.169-2.667,3.575-7.398,0.907-10.567l-18.037-21.427c-2.272-2.699-5.537-4.247-8.958-4.247c-3.421,0-6.686,1.548-8.957,4.247l-18.037,21.427c-2.668,3.169-2.262,7.9,0.907,10.567c1.407,1.185,3.121,1.763,4.826,1.763c2.137,0,4.258-0.908,5.741-2.67l7.901-9.386v80.751c0,8.686,5.927,21.607,22.254,21.607c0.652,0,20.27,0.04,39.968,0.079c19.874,0.041,39.829,0.081,40.498,0.081c33.681,0,61.081-27.4,61.081-61.08C312.602,164.644,285.201,137.244,251.52,137.244z"
  })), t.createElement("input", Object.assign({}, T()))))), y && t.createElement("div", {
    className: "loading"
  }, t.createElement(l, {
    type: y ? "ThreeDots" : "Oval",
    color: "#ed64a6",
    height: 100,
    width: 100
  })));
},
    se = function se(e) {
  var r = e.text,
      n = e.onChange;
  return t.createElement("div", {
    className: c("max-w-xl mx-auto py-6")
  }, t.createElement(te, {
    renderBlock: function renderBlock(e) {
      return t.createElement("p", Object.assign({
        className: "text-gray-700"
      }, e.attributes), e.children);
    },
    value: r,
    placeholder: "Type a text...",
    propName: "text",
    onChange: n,
    allowedFeatures: [exports.types.RichTextFeatures.Bold, exports.types.RichTextFeatures.Italic, exports.types.RichTextFeatures.Highlight, exports.types.RichTextFeatures.Code, exports.types.RichTextFeatures.Link]
  }));
},
    ue = [{
  name: "paragraph",
  label: "Paragraph",
  superType: exports.types.BlockSuperType.Single,
  render: function render(e) {
    return t.createElement(se, Object.assign({}, e));
  },
  getDefaultProps: function getDefaultProps() {
    return {
      text: p.deserialize("Lorem ipsum dolor sit amet")
    };
  },
  textEditProps: ["text"]
}],
    de = [{
  name: "page",
  pluralName: "pages",
  defaultLocked: !1,
  defaultStatus: exports.types.PageStatus.Draft,
  defaultLanguage: "en",
  getDefaultContent: function getDefaultContent() {
    return [];
  }
}],
    pe = require("react-query").useQuery;

"undefined" != typeof Symbol && (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))), "undefined" != typeof Symbol && (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator")));

var me = require("react-query").useMutation,
    ge = function ge() {
  var e = me(function (e) {
    return ae(re + "/session", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appId: e.appId,
        email: e.email,
        password: e.password
      })
    });
  })[0],
      r = t.useContext(_).appId,
      n = t.useContext(k).setUser;
  return {
    loginUser: function loginUser(t, o) {
      try {
        var a = {
          appId: r,
          email: t,
          password: o
        };
        return Promise.resolve(function (t, r) {
          try {
            var o = Promise.resolve(e(a)).then(function (e) {
              return n(w({}, e.user, {
                token: e.authToken
              })), localStorage.setItem(ne, e.authToken), e;
            });
          } catch (e) {
            return r();
          }

          return o && o.then ? o.then(void 0, r) : o;
        }(0, function () {
          return n(null), null;
        }));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    logoutUser: function logoutUser() {
      n(null), localStorage.removeItem(ne);
    }
  };
},
    fe = function fe(e) {
  return t.createElement("svg", {
    className: e.className,
    viewBox: "0 0 450 100"
  }, t.createElement("g", {
    id: "layer1",
    transform: "translate(0,-197)"
  }, t.createElement("g", {
    transform: "matrix(6.6679482,0,0,6.6679482,-210.3068,-1556.9577)",
    id: "g2125"
  }, t.createElement("path", {
    style: {
      fill: "#23192d",
      stroke: "none",
      strokeWidth: 4.32088709
    },
    d: "M 846.20898 126.58203 C 834.22573 126.58203 823.27838 129.29152 813.36914 134.70703 C 803.57512 140.12254 795.85494 147.5535 790.20898 157.00195 C 784.56302 166.45024 781.74023 176.99322 781.74023 188.63086 C 781.74023 200.38359 784.50636 211.04193 790.03711 220.60547 C 795.56784 230.16918 803.17277 237.7155 812.85156 243.24609 C 822.53034 248.66177 833.30383 251.37109 845.17188 251.37109 C 853.92886 251.37109 862.62775 249.41183 871.26953 245.49414 C 880.02653 241.57645 887.63146 236.27657 894.08398 229.59375 L 878.00977 212.13672 C 873.63126 216.51526 868.61861 220.02965 862.97266 222.67969 C 857.44193 225.21464 851.97021 226.48242 846.55469 226.48242 C 839.7565 226.48242 833.53267 224.81016 827.88672 221.46875 C 822.24075 218.01192 817.80633 213.40369 814.58008 207.64258 C 811.35381 201.76622 809.74023 195.31391 809.74023 188.28516 C 809.74023 181.25657 811.35381 174.86088 814.58008 169.09961 C 817.80633 163.3385 822.24075 158.78884 827.88672 155.44727 C 833.53267 152.10586 839.7565 150.43359 846.55469 150.43359 C 852.20066 150.43359 857.78763 151.87531 863.31836 154.75586 C 868.96433 157.52133 873.86172 161.3795 878.00977 166.33398 L 893.91016 146.80469 C 887.91852 140.58256 880.65935 135.6852 872.13281 132.11328 C 863.60626 128.42611 854.96598 126.58203 846.20898 126.58203 z M 1598.3184 127.10156 C 1589.7918 127.10156 1582.3021 128.42613 1575.8496 131.07617 C 1569.3971 133.72638 1564.3844 137.52972 1560.8125 142.48438 C 1557.2406 147.43903 1555.4551 153.14128 1555.4551 159.59375 C 1555.4551 166.9681 1557.1839 172.90285 1560.6406 177.39648 C 1564.2126 181.89028 1568.5337 185.28931 1573.6035 187.59375 C 1578.6734 189.89819 1585.241 192.25999 1593.3066 194.67969 C 1599.8744 196.6387 1605.0589 198.4242 1608.8613 200.03711 C 1612.7789 201.65035 1616.0041 203.84017 1618.5391 206.60547 C 1621.074 209.37077 1622.3418 212.88515 1622.3418 217.14844 C 1622.3418 222.56395 1619.98 226.88501 1615.2559 230.11133 C 1610.6469 233.22239 1604.3098 234.77734 1596.2441 234.77734 C 1589.4459 234.77734 1582.4173 233.28097 1575.1582 230.28516 C 1568.0143 227.17409 1561.562 222.79446 1555.8008 217.14844 L 1548.3691 231.49414 C 1554.476 237.25542 1561.7352 241.86365 1570.1465 245.32031 C 1578.5578 248.77698 1587.1981 250.50586 1596.0703 250.50586 C 1604.8273 250.50586 1612.5475 249.12272 1619.2305 246.35742 C 1626.0287 243.47687 1631.2718 239.44493 1634.959 234.25977 C 1638.7614 229.07477 1640.6621 223.02482 1640.6621 216.11133 C 1640.6621 208.62189 1638.8766 202.63052 1635.3047 198.13672 C 1631.7328 193.52783 1627.4116 190.07202 1622.3418 187.76758 C 1617.272 185.46314 1610.6477 183.04277 1602.4668 180.50781 C 1595.8991 178.43287 1590.7711 176.64737 1587.084 175.15039 C 1583.3968 173.53715 1580.2849 171.40395 1577.75 168.75391 C 1575.2151 165.98844 1573.9473 162.47422 1573.9473 158.21094 C 1573.9473 153.4868 1576.0219 149.80043 1580.1699 147.15039 C 1584.4332 144.38492 1590.0788 143.00195 1597.1074 143.00195 C 1602.1773 143.00195 1607.7095 143.92399 1613.7012 145.76758 C 1619.808 147.49591 1625.6841 150.14683 1631.3301 153.71875 L 1638.2422 138.85352 C 1632.8267 135.2816 1626.6048 132.45887 1619.5762 130.38477 C 1612.6627 128.19558 1605.5774 127.10156 1598.3184 127.10156 z M 1370.1328 127.44727 C 1358.4952 127.44727 1347.837 130.1548 1338.1582 135.57031 C 1328.4794 140.98582 1320.8159 148.41678 1315.1699 157.86523 C 1309.6392 167.19826 1306.875 177.51265 1306.875 188.80469 C 1306.875 200.21181 1309.6392 210.63765 1315.1699 220.08594 C 1320.7007 229.53422 1328.2489 237.02392 1337.8125 242.55469 C 1347.3761 247.9702 1357.919 250.67969 1369.4414 250.67969 C 1377.7375 250.67969 1385.9168 249.00742 1393.9824 245.66602 C 1402.0481 242.20935 1409.1353 237.48593 1415.2422 231.49414 L 1405.2168 220.60547 C 1400.4926 225.09927 1395.0776 228.67206 1388.9707 231.32227 C 1382.8639 233.85705 1376.642 235.12305 1370.3047 235.12305 C 1361.7781 235.12305 1353.9427 233.05037 1346.7988 228.90234 C 1339.655 224.75431 1334.0094 219.10673 1329.8613 211.96289 C 1325.7133 204.81905 1323.6387 197.04218 1323.6387 188.63086 C 1323.6387 180.10429 1325.7133 172.32741 1329.8613 165.29883 C 1334.0094 158.15482 1339.655 152.50741 1346.7988 148.35938 C 1353.9427 144.21134 1361.7781 142.13867 1370.3047 142.13867 C 1376.7572 142.13867 1383.0377 143.52164 1389.1445 146.28711 C 1395.2514 148.93715 1400.6078 152.68013 1405.2168 157.51953 L 1415.0684 145.59375 C 1409.3072 139.83264 1402.4524 135.39817 1394.502 132.28711 C 1386.6667 129.06079 1378.5441 127.44727 1370.1328 127.44727 z M 421.75586 128.48438 L 421.75586 249.46875 L 449.06445 249.46875 L 449.06445 214.90234 L 474.29883 214.90234 L 476.89062 214.90234 L 496.07617 249.46875 L 527.01367 249.46875 L 501.26172 209.54492 C 508.63602 206.08809 514.22301 201.07554 518.02539 194.50781 C 521.94301 187.82483 523.90234 179.81545 523.90234 170.48242 C 523.90234 157.11645 519.58123 146.80402 510.93945 139.54492 C 502.29767 132.17057 490.08446 128.48438 474.29883 128.48438 L 421.75586 128.48438 z M 546.99414 128.48438 L 546.99414 249.46875 L 641.01758 249.46875 L 641.01758 226.82812 L 574.30273 226.82812 L 574.30273 200.03711 L 632.54883 200.03711 L 632.54883 177.39648 L 574.30273 177.39648 L 574.30273 151.125 L 639.11719 151.125 L 639.11719 128.48438 L 546.99414 128.48438 z M 701.1582 128.48438 L 648.61719 249.46875 L 676.78906 249.46875 L 686.29492 225.96289 L 742.29297 225.96289 L 751.79883 249.46875 L 781.00781 249.46875 L 729.33008 128.48438 L 701.1582 128.48438 z M 898.29297 128.48438 L 898.29297 151.64453 L 935.10742 151.64453 L 935.10742 249.46875 L 962.41602 249.46875 L 962.41602 151.64453 L 999.40234 151.64453 L 999.40234 128.48438 L 898.29297 128.48438 z M 1018.166 128.48438 L 1018.166 249.46875 L 1070.709 249.46875 C 1084.4206 249.46875 1095.1355 246.58745 1102.8555 240.82617 C 1110.6907 234.94981 1114.6074 226.82719 1114.6074 216.45703 C 1114.6074 208.27623 1112.189 201.47801 1107.3496 196.0625 C 1102.6255 190.53106 1096.0578 187.13204 1087.6465 185.86523 C 1094.4447 184.25216 1099.8011 181.08368 1103.7188 176.35938 C 1107.6364 171.51998 1109.5957 165.6438 1109.5957 158.73047 C 1109.5957 149.28219 1106.0247 141.90784 1098.8809 136.60742 C 1091.8522 131.19191 1082.1727 128.48438 1069.8438 128.48438 L 1018.166 128.48438 z M 1141.3789 128.48438 L 1141.3789 249.46875 L 1157.9707 249.46875 L 1157.9707 211.79102 L 1188.7363 211.79102 C 1190.4647 211.79102 1192.7112 211.67549 1195.4766 211.44531 L 1219.5 249.46875 L 1238.5117 249.46875 L 1210.3398 208.50586 C 1218.8664 205.51005 1225.3774 200.67127 1229.8711 193.98828 C 1234.48 187.3053 1236.7832 179.06749 1236.7832 169.27344 C 1236.7832 156.25323 1232.5793 146.22797 1224.168 139.19922 C 1215.8719 132.05538 1204.0611 128.48438 1188.7363 128.48438 L 1141.3789 128.48438 z M 1266.2793 128.48438 L 1266.2793 249.46875 L 1282.8711 249.46875 L 1282.8711 128.48438 L 1266.2793 128.48438 z M 1438.4395 128.48438 L 1438.4395 249.46875 L 1455.0312 249.46875 L 1455.0312 217.83984 L 1477.3281 193.64258 L 1519.8457 249.46875 L 1539.8945 249.46875 L 1488.9082 180.67969 L 1536.7832 128.48438 L 1516.9062 128.48438 L 1455.0312 196.4082 L 1455.0312 128.48438 L 1438.4395 128.48438 z M 1157.9707 143.52148 L 1188.7363 143.52148 C 1199.1065 143.52148 1207.0572 145.76809 1212.5879 150.26172 C 1218.1186 154.64026 1220.8828 161.14919 1220.8828 169.79102 C 1220.8828 178.66319 1218.1186 185.40479 1212.5879 190.01367 C 1207.0572 194.50747 1199.1065 196.75391 1188.7363 196.75391 L 1157.9707 196.75391 L 1157.9707 143.52148 z M 1034.7578 143.69336 L 1068.9805 143.69336 C 1076.47 143.57827 1082.2308 145.07643 1086.2637 148.1875 C 1090.4117 151.2984 1092.4844 155.73482 1092.4844 161.49609 C 1092.4844 167.37246 1090.4117 171.92407 1086.2637 175.15039 C 1082.2308 178.26146 1076.47 179.81641 1068.9805 179.81641 L 1034.7578 179.81641 L 1034.7578 143.69336 z M 449.06445 151.125 L 474.29883 151.125 C 481.90359 151.125 487.72303 152.85371 491.75586 156.31055 C 495.90391 159.65196 497.97656 164.66467 497.97656 171.34766 C 497.97656 178.1459 495.90391 183.33042 491.75586 186.90234 C 487.72303 190.35901 481.90359 192.08789 474.29883 192.08789 L 449.06445 192.08789 L 449.06445 151.125 z M 714.4668 157.00195 L 733.47852 204.01367 L 695.2832 204.01367 L 714.4668 157.00195 z M 1034.7578 194.85352 L 1068.9805 194.85352 C 1077.9679 194.85352 1084.9966 196.58045 1090.0664 200.03711 C 1095.1362 203.49377 1097.6699 208.27594 1097.6699 214.38281 C 1097.6699 220.7202 1095.1362 225.67613 1090.0664 229.24805 C 1084.9966 232.70706 1077.9679 234.37737 1068.9805 234.25977 L 1034.7578 234.25977 L 1034.7578 194.85352 z ",
    transform: "matrix(0.03967987,0,0,0.03967987,31.539957,263.04309)",
    id: "path2217"
  }), t.createElement("g", {
    transform: "matrix(0.45707395,0,0,0.45707395,-5.476545,228.6835)",
    id: "g2123"
  }, t.createElement("path", {
    style: {
      color: "#000000",
      fill: "#b43278",
      strokeWidth: 6.3499999,
      strokeLinecap: "round"
    },
    d: "m 89.441569,80.202363 c -4.314359,-0.08215 -4.314359,6.431634 0,6.349484 h 2.601907 c 4.314357,0.08215 4.314357,-6.431634 0,-6.349484 z m 13.696321,8.201051 c -4.293622,-0.06072 -4.293622,6.410722 0,6.35 h 2.60191 c 4.29362,0.06072 4.29362,-6.410724 0,-6.35 z m -13.712341,8.201565 c -4.293532,-0.06063 -4.293532,6.410631 0,6.350001 h 2.601907 c 4.293531,0.0606 4.293531,-6.410625 0,-6.350001 z",
    id: "path2119"
  }), t.createElement("path", {
    style: {
      color: "#000000",
      fill: "#f65a8e",
      stroke: "none",
      strokeWidth: 6.3499999,
      strokeLinecap: "round"
    },
    d: "m 99.752893,80.202362 c -4.314356,-0.08215 -4.314356,6.431635 0,6.349484 h 5.970697 c 4.31436,0.08215 4.31436,-6.431634 0,-6.349484 z m -10.327018,8.201052 c -4.293624,-0.06072 -4.293624,6.410722 0,6.35 h 5.970696 c 4.293624,0.06072 4.293624,-6.410725 0,-6.35 z m 10.34252,8.201564 c -4.293528,-0.06063 -4.293528,6.410632 0,6.350002 h 5.971215 c 4.29353,0.0606 4.29353,-6.410626 0,-6.350002 z",
    id: "path2121"
  })))));
},
    be = function be(e) {
  var r = e.renderMenu,
      n = ge().logoutUser,
      o = t.useContext(_).logo,
      a = t.useContext(k).user;
  return t.createElement("div", {
    className: "fixed top-0 inset-x-0 flex bg-white shadow z-50 h-10"
  }, t.createElement("div", {
    className: "w-full mx-auto px-6 flex justify-between items-center"
  }, o ? t.createElement("img", {
    src: o,
    alt: "React Bricks",
    className: "h-6"
  }) : t.createElement(fe, {
    className: "h-6"
  }), a && r && r(), a && t.createElement("div", {
    className: "flex flex-row text-xs leading-none text-gray-600 uppercase"
  }, t.createElement("div", {
    className: "mr-2"
  }, a.firstName, " ", a.lastName), t.createElement("button", {
    className: "hover:text-gray-900",
    onClick: function onClick() {
      return n();
    }
  }, t.createElement(m.FiPower, null)))));
},
    ye = function ye() {
  var e = t.useContext(_),
      n = e.renderLocalLink,
      o = e.editorPath,
      a = e.playgroundPath,
      i = e.appSettingsPath,
      l = t.useContext(k).user;
  return r.createElement(be, {
    renderMenu: function renderMenu() {
      var e = function e(_e2) {
        return n({
          href: _e2.href,
          children: _e2.children,
          className: "px-4 py-2 border-b-4 uppercase text-sm tracking-wide border-transparent text-gray-700",
          activeClassName: "px-4 py-2 border-b-4 uppercase text-sm tracking-wide border-pink-400 text-gray-900 font-semibold",
          isAdmin: !0
        });
      };

      return r.createElement("div", {
        className: "flex flex-row items-center"
      }, r.createElement("div", {
        className: "hidden px-4 py-2 border-b-4 uppercase text-sm tracking-wide border-transparent text-gray-700 border-pink-400 text-gray-900 font-semibold"
      }), r.createElement(e, {
        href: o
      }, "Editor"), r.createElement(e, {
        href: a
      }, "Playground"), r.createElement(e, {
        href: i
      }, (null == l ? void 0 : l.isAdmin) ? "App settings" : "Deploy"));
    }
  });
},
    he = function he(e) {
  var r = e.isLogin,
      n = void 0 !== r && r,
      o = t.useContext(_),
      a = o.navigate,
      i = o.loginPath,
      l = o.editorPath,
      c = t.useContext(k).user;
  return t.useEffect(function () {
    n ? c && c.email && a(l) : c || a(i);
  }, [n, c]), null;
},
    xe = function (e) {
  var t, n;

  function o() {
    return e.apply(this, arguments) || this;
  }

  n = e, (t = o).prototype = Object.create(n.prototype), t.prototype.constructor = t, t.__proto__ = n;
  var a = o.prototype;
  return a.componentDidMount = function () {
    var e = this;
    this.iframeHead = this.node.contentDocument.head, this.iframeRoot = this.node.contentDocument.body, this.props.styles && this.props.styles.forEach(function (t) {
      return e.iframeHead.appendChild(t.cloneNode(!0));
    }), this.props.stylesheets && this.props.stylesheets.forEach(function (t) {
      return e.iframeHead.appendChild(t.cloneNode(!0));
    }), this.forceUpdate();
  }, a.componentDidUpdate = function (e) {
    var t = this;
    (this.props.styles && this.props.styles !== e.styles || this.props.stylesheets && this.props.stylesheets !== e.stylesheets) && (this.iframeHead.innerHTML = "", this.props.styles.forEach(function (e) {
      return t.iframeHead.appendChild(e.cloneNode(!0));
    }), this.props.stylesheets.forEach(function (e) {
      return t.iframeHead.appendChild(e.cloneNode(!0));
    }));
  }, a.render = function () {
    var e = this,
        t = this.props,
        n = t.children,
        o = t.head,
        a = C(t, ["children", "head"]);
    return r.createElement("iframe", Object.assign({
      title: "content"
    }, a, {
      ref: function ref(t) {
        return e.node = t;
      }
    }), this.iframeHead && g.createPortal(o, this.iframeHead), this.iframeRoot && g.createPortal(n, this.iframeRoot));
  }, o;
}(t.Component),
    ve = require("react-query").useQuery,
    ke = function ke(e) {
  var t = void 0 === e ? {} : e,
      r = t.type,
      n = t.tag;
  return ve(["pages", {
    type: r,
    tag: n
  }], function () {
    return ae(re + "/pages?type=" + (r || "") + "&tag=" + (n || ""), {
      headers: {
        Authorization: "Bearer " + localStorage.getItem(ne)
      }
    });
  });
},
    Ee = require("react-query").useMutation,
    we = require("react-query").queryCache,
    Ce = function Ce() {
  var e = t.useContext(_).pageTypeSchema,
      r = t.useContext(k),
      n = r.currentPage,
      o = r.setCurrentPage,
      a = r.previewMode,
      i = r.sidebarCollapsed,
      u = ke(),
      d = u.data,
      p = u.error,
      g = u.isLoading,
      b = u.isFetching,
      y = Ee(function (e) {
    var t = e.type,
        r = e.name,
        n = e.content,
        o = e.status,
        a = e.isLocked;
    return ae(re + "/pages", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(ne),
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        id: f.v4(),
        type: t,
        name: r,
        content: JSON.stringify(n),
        status: o,
        isLocked: a
      })
    });
  }, {
    onSuccess: function onSuccess(e) {
      we.refetchQueries("pages"), 423 === e.statusCode ? s.warn("Creating pages not allowed on this demo", {
        position: "bottom-right"
      }) : e.statusCode ? s.error("An error occurred while creating the new page", {
        position: "bottom-right"
      }) : s.success("New page created", {
        position: "bottom-right"
      });
    },
    onError: function onError() {
      s.error("An error occurred while creating the new page", {
        position: "bottom-right"
      });
    }
  })[0],
      h = t.useState(""),
      x = h[0],
      v = h[1],
      E = t.useState(""),
      C = E[0],
      N = E[1],
      S = t.useState([]),
      T = S[0],
      L = S[1],
      I = t.useState(""),
      P = I[0],
      B = I[1];
  t.useEffect(function () {
    var t = e.map(function (e, t) {
      return w({}, e, {
        isOpen: !t
      });
    });
    L(t);
  }, [e]);

  var O = function O() {
    v(""), N("");
  },
      z = function z(t) {
    t.preventDefault();
    var r = e.find(function (e) {
      return e.name === x;
    });

    if (r && C) {
      var n = {
        id: f.v4(),
        type: x,
        name: C,
        status: r.defaultStatus || exports.types.PageStatus.Draft,
        meta: {
          language: r.defaultLanguage || "en"
        },
        isLocked: !!r.defaultLocked,
        content: r.getDefaultContent ? r.getDefaultContent() : []
      };
      y(n);
    }

    v(""), N("");
  },
      A = function A(e) {
    return function () {
      L(T.map(function (t) {
        return t.name === e ? w({}, t, {
          isOpen: !t.isOpen
        }) : t;
      }));
    };
  },
      j = function j(e) {
    return e.isOpen || P;
  };

  return p || (null == d ? void 0 : d.error) ? null : t.createElement("div", {
    style: {
      width: a || i ? 0 : 220,
      transition: "width 300ms"
    }
  }, !a && !i && t.createElement("div", {
    className: "fixed top-0 pt-12 pb-12 w-48 h-full overflow-y-auto scrolling-touch pr-4"
  }, t.createElement("nav", {
    className: "overflow-y-auto"
  }, t.createElement("div", {
    className: "relative mt-4 mb-4"
  }, t.createElement("input", {
    type: "text",
    value: P,
    onChange: function onChange(e) {
      B(e.target.value);
    },
    className: "py-2 px-4 pr-8 leading-none w-full border border-gray-200 rounded-full outline-none",
    placeholder: "Search page"
  }), t.createElement(m.FiSearch, {
    className: "absolute text-gray-400",
    style: {
      top: 9,
      right: 11
    }
  })), T.map(function (e) {
    return t.createElement("div", {
      className: "mt-4 mb-4",
      key: e.name
    }, t.createElement("div", {
      className: "flex flex-row justify-between items-center border-b border-gray-300 pb-1 mb-2"
    }, j(e) ? t.createElement("button", {
      onClick: A(e.name),
      className: "mr-1 text-gray-600"
    }, t.createElement(m.FiChevronDown, null)) : t.createElement("button", {
      onClick: A(e.name),
      className: "mr-1 text-gray-600"
    }, t.createElement(m.FiChevronRight, null)), t.createElement("h3", {
      className: "w-full text-xs leading-none font-bold uppercase tracking-wider text-gray-600"
    }, e.pluralName, " "), g || b ? t.createElement(l, {
      type: "Puff",
      color: "#ed64a6",
      height: 16,
      width: 16
    }) : t.createElement("button", {
      type: "button",
      onClick: (r = e.name, function () {
        v(r), N("");
      }),
      title: "Add " + e.name,
      className: "text-gray-600 hover:text-gray-700 px-1"
    }, t.createElement(m.FiPlus, {
      className: "text-sm"
    }))), x === e.name && t.createElement("form", {
      onSubmit: z,
      className: "flex flex-row justify-between items-center mb-3"
    }, t.createElement("input", {
      autoFocus: !0,
      className: "bg-white border border-gray-200 rounded outline-none focus:border-pink-400 px-2",
      style: {
        width: 132
      },
      type: "text",
      value: C,
      onChange: function onChange(e) {
        return N(e.target.value);
      }
    }), t.createElement("div", null, t.createElement("button", {
      type: "submit",
      className: "px-1 text-sm text-green-500 hover:text-green-600"
    }, t.createElement(m.FiCheck, null)), t.createElement("button", {
      type: "button",
      onClick: O,
      className: "px-1 text-sm text-gray-400 hover:text-gray-500"
    }, t.createElement(m.FiX, null)))), t.createElement("ul", null, d && j(e) && function (e, t) {
      return e ? e.filter(function (e) {
        return e.type === t;
      }) : [];
    }(d, e.name).filter(function (e) {
      return e.name.toLowerCase().indexOf(P.toLowerCase()) > -1;
    }).map(function (e) {
      return t.createElement("li", {
        key: e.id,
        onClick: function onClick() {
          return o(e.id || "");
        },
        className: c("text-sm px-1 py-px mb-1 flex flex-row justify-between items-center text-gray-600 hover:text-gray-800 cursor-pointer", {
          "bg-white rounded text-pink-700 hover:text-pink-700": e.id === n
        })
      }, t.createElement("div", {
        className: "flex flex-row justify-start items-center flex-1"
      }, t.createElement("div", {
        className: "mr-2"
      }, e.isLocked ? t.createElement(m.FiLock, {
        className: "text-pink-400"
      }) : t.createElement(m.FiUnlock, {
        className: "text-gray-400"
      })), t.createElement("div", null, e.name)), e.status === exports.types.PageStatus.Draft && t.createElement(m.FiEyeOff, {
        className: "text-gray-400"
      }));
    })));
    var r;
  }))), t.createElement("div", {
    className: "fixed bg-gray-100 bottom-0 left-0 py-1 w-56 pl-6 text-xs flex flex-row justify-start items-center"
  }, t.createElement("div", null, "Powered by"), t.createElement("div", {
    className: "w-24"
  }, t.createElement(fe, null))));
},
    Ne = require("react-query").useQuery,
    Se = function Se(e) {
  return Ne(e && ["page", {
    pageId: e
  }], function () {
    return ae(re + "/pages/" + e, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem(ne)
      }
    });
  }, {
    refetchOnWindowFocus: !1
  });
},
    Te = function Te(e, t, r) {
  return !(r && r.find(function (t) {
    return t === e;
  }) || t && !t.find(function (t) {
    return t === e;
  }));
},
    Le = {
  id: "",
  type: "",
  slug: "",
  name: "",
  meta: {},
  status: exports.types.PageStatus.Draft,
  isLocked: !1,
  content: [],
  tags: []
},
    Ie = function Ie(e, t, r) {
  if (!e || !e.type || !e.content) return Le;
  var n = t.find(function (t) {
    return t.name === e.type;
  });
  if (!n) return Le;
  var o = Pe(r, e.content, n.allowedBlockTypes, n.excludedBlockTypes);
  return w({}, e, {
    content: o.blocks,
    invalidBlocksTypes: o.invalidBlocksTypes
  });
},
    Pe = function e(t, r, n, o) {
  return r.reduce(function (r, a) {
    var i = t.find(function (e) {
      return e.name === a.type;
    });
    if (!i || !Te(i.name, n, o)) return w({}, r, {
      invalidBlocksTypes: [].concat(r.invalidBlocksTypes, [a.type])
    });
    var l = w({}, a, {
      props: w({}, a.props)
    });
    return i.textEditProps && i.textEditProps.forEach(function (e) {
      l.props[e] = d.Value.fromJSON(l.props[e]);
    }), l.props.items && (l.props.items = e(t, l.props.items).blocks), w({}, r, {
      blocks: [].concat(r.blocks, [l])
    });
  }, {
    blocks: [],
    invalidBlocksTypes: []
  });
},
    Be = require("react-query").useMutation,
    Oe = require("react-query").queryCache,
    ze = function ze(e) {
  return Be(function (t) {
    var r = t.page,
        n = {
      type: r.type,
      name: r.name,
      slug: r.slug,
      content: JSON.stringify(r.content),
      meta: JSON.stringify(r.meta),
      status: r.status,
      isLocked: r.isLocked
    };
    return ae(re + "/pages/" + e, {
      method: "PUT",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(ne),
        "Content-Type": "application/json"
      },
      body: JSON.stringify(n)
    });
  }, {
    onSuccess: function onSuccess(t) {
      Oe.refetchQueries("pages"), Oe.refetchQueries(["page", {
        pageId: e
      }]), 423 === t.statusCode ? s.warn("Saving not allowed on this demo", {
        position: "bottom-right"
      }) : t.statusCode ? s.error("An error occurred while saving the page", {
        position: "bottom-right"
      }) : s.success("Page saved", {
        position: "bottom-right"
      });
    },
    onError: function onError() {
      s.error("An error occurred while saving the page", {
        position: "bottom-right"
      });
    }
  });
},
    Ae = require("react-query").useMutation,
    je = require("react-query").queryCache,
    De = function De(e) {
  var r = e.page,
      n = t.useContext(_).blockTypeSchema,
      o = t.useContext(k),
      a = o.previewMode,
      i = o.setPreviewMode,
      l = o.sidebarCollapsed,
      c = o.setSidebarCollapsed,
      u = ze(r.id)[0],
      d = Ae(function (e) {
    return ae(re + "/pages/" + e.pageId + "/duplicate", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(ne)
      }
    });
  }, {
    onSuccess: function onSuccess(e) {
      je.refetchQueries("pages"), 423 === e.statusCode ? s.warn("Creating pages not allowed on this demo", {
        position: "bottom-right"
      }) : e.statusCode ? s.error("An error occurred while duplicating the page", {
        position: "bottom-right"
      }) : s.success("Page duplicated", {
        position: "bottom-right"
      });
    },
    onError: function onError() {
      s.error("An error occurred while duplicating the page", {
        position: "bottom-right"
      });
    }
  })[0],
      p = r.content.reduce(function (e, t) {
    var r = n.find(function (e) {
      return e.name === t.type;
    });
    return r ? e && !!function (e, t) {
      return !t.sideEditProps || t.sideEditProps.reduce(function (t, r) {
        return !("function" == typeof r.validate && !r.validate(e.props[r.name], e.props)) && t;
      }, !0);
    }(t, r) : e;
  }, !0);
  return a ? t.createElement("div", {
    className: "fixed z-20 py-1 flex flex-row justify-center items-center",
    style: {
      top: 40,
      left: 0,
      right: 0
    }
  }, t.createElement("button", {
    className: "block bg-gray-100 my-3 px-3 py-1 uppercase text-xs text-pink-500 border border-pink-500 hover:border-pink-600 hover:text-pink-600 hover:shadow-lg\n          rounded",
    onClick: function onClick() {
      return i(!1);
    }
  }, "Exit preview")) : t.createElement("div", {
    className: "fixed flex z-20 bg-gray-100",
    style: {
      top: 40,
      left: l ? 0 : 220,
      right: 24,
      transition: "all 300ms"
    }
  }, t.createElement("div", {
    className: "w-full flex flex-row justify-between items-center py-3"
  }, t.createElement("div", {
    className: "flex flex-row justify-start items-center"
  }, t.createElement("h2", {
    className: "pl-8 text-lg font-semibold text-gray-700 truncate"
  }, t.createElement("button", {
    className: "focus:outline-none align-middle text-gray-500 hover:text-gray-700 mr-1",
    onClick: function onClick() {
      c(!l);
    }
  }, t.createElement(m.FiMenu, null)), " ", r.name), t.createElement("button", {
    className: "block ml-4 px-3 uppercase text-xs text-pink-500 border border-pink-500 hover:border-pink-600 hover:text-pink-600 hover:shadow-lg rounded",
    onClick: function onClick(e) {
      e.preventDefault(), d({
        pageId: r.id
      });
    }
  }, "Duplicate page")), t.createElement("div", {
    className: "flex flex-row justify-end"
  }, t.createElement("button", {
    className: "block mr-2 px-3 py-1 uppercase text-xs text-pink-500 border border-pink-500 hover:border-pink-600 hover:text-pink-600 hover:shadow-lg rounded",
    onClick: function onClick() {
      return i(!0);
    }
  }, "Preview"), t.createElement("button", {
    className: "px-3 py-1 bg-pink-500 hover:bg-pink-600 hover:shadow-lg uppercase text-xs text-white font-bold rounded disabled:opacity-75 disabled:cursor-not-allowed",
    onClick: function onClick(e) {
      e.preventDefault(), u({
        pageId: r.id,
        page: r
      });
    },
    disabled: !p
  }, "Save"))));
},
    Fe = function Fe(e) {
  var r = e.contentLength,
      n = e.block,
      o = e.index,
      a = e.focused,
      i = e.locked,
      l = e.setFocused,
      c = e.setAddAfterBlockId,
      s = e.handleChange,
      u = e.handleAddBlockAfter,
      d = e.handleRemoveBlock,
      p = e.handleSort,
      g = t.useContext(_).blockTypeSchema,
      f = t.useContext(k).previewMode,
      y = function y(e) {
    var t = g.find(function (t) {
      return t.name === e.type;
    });

    if (t) {
      var r = null;
      t.superType === exports.types.BlockSuperType.Repeater && (r = e.props.items.map(function (r) {
        return r.type !== t.itemsType ? null : function (e, t) {
          var r = g.find(function (t) {
            return t.name === e.type;
          });

          if (r) {
            var n = w({}, e.props, {
              onChange: s(e.id, t),
              onClick: function onClick(r) {
                r.stopPropagation(), l({
                  blockId: t,
                  itemId: e.id
                }), c("");
              },
              onFocus: function onFocus(r) {
                r.stopPropagation(), setTimeout(function () {
                  l({
                    blockId: t,
                    itemId: e.id
                  }), c("");
                }, 0);
              },
              key: e.id,
              style: {
                outline: e.id !== a.itemId || f ? "none" : "2px solid #fb83a3"
              }
            });
            return r.render(n);
          }
        }(r, e.id);
      }));
      var n = w({}, e.props, {
        onChange: s(e.id, "")
      });
      return t.superType === exports.types.BlockSuperType.Repeater && (n.renderItems = r), t.render(n);
    }
  },
      h = {};

  return n.id !== a.blockId || f || (h.border = "2px solid #fb83a3"), "PREVIEW_NEW" === n.id ? t.createElement("div", null, y(n)) : t.createElement("div", {
    key: n.id,
    style: {
      position: "relative",
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch"
    }
  }, t.createElement("style", null, "\nbutton.rb-action {\n  box-sizing: border-box;\n  font-family: inherit;\n  font-size: 100%;\n  line-height: 1.15;\n  margin: 0;\n  overflow: visible;\n  -webkit-appearance: button;\n  padding: 0;\n  line-height: inherit;\n  color: inherit;\n  cursor: pointer;\n  border: none;\n  background-color: transparent;\n}\nbutton.rb-action:focus {\n  outline: 1px dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n}"), t.createElement("div", {
    style: w({}, h),
    onClick: function onClick() {
      l({
        blockId: n.id,
        itemId: ""
      }), c("");
    },
    onFocus: function onFocus() {
      return setTimeout(function () {
        l({
          blockId: n.id,
          itemId: ""
        }), c("");
      }, 0);
    }
  }, y(n)), n.id === a.blockId && !f && !i && t.createElement("div", {
    style: {
      boxSizing: "border-box",
      alignSelf: "center",
      marginTop: -14,
      padding: 4,
      backgroundColor: "#fff",
      borderRadius: 100,
      width: 26,
      height: 26,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: 18,
      color: "#f65a8e"
    }
  }, t.createElement("button", {
    className: "rb-action"
  }, t.createElement(m.FiPlusCircle, {
    onClick: u(n.id)
  }))), n.id === a.blockId && !f && !i && t.createElement(t.Fragment, null, t.createElement("div", {
    style: {
      display: "flex",
      position: "absolute",
      right: 0,
      top: -22,
      backgroundColor: "#fb83a3",
      color: "#fff",
      padding: "0.25em 0.5em",
      borderTopLeftRadius: "0.25rem",
      borderTopRightRadius: "0.25rem"
    }
  }, o > 0 && t.createElement("button", {
    className: "rb-action",
    style: {
      marginRight: 4
    }
  }, t.createElement(m.FiChevronUp, {
    onClick: p(n.id, exports.types.SortDirection.Up)
  })), o < r - 1 && t.createElement("button", {
    className: "rb-action",
    style: {
      marginRight: 4
    }
  }, t.createElement(m.FiChevronDown, {
    onClick: p(n.id, exports.types.SortDirection.Down)
  })), t.createElement("button", {
    className: "rb-action"
  }, t.createElement(b.AiOutlineDelete, {
    onClick: d(n.id)
  })))));
},
    Re = function Re(e) {
  var r = e.previewNewBlock;
  return t.createElement("div", {
    style: {
      border: "2px solid #f65a8e"
    }
  }, t.createElement("div", {
    style: {
      color: "#b43179",
      letterSpacing: "0.05em",
      paddingTop: "1rem",
      paddingBottom: "1rem",
      textAlign: "center"
    }
  }, "NEW BLOCK HERE: SELECT ON THE RIGHT »"), r && t.createElement(Fe, {
    block: r,
    contentLength: 0,
    index: 1,
    focused: {
      blockId: "",
      itemId: ""
    },
    locked: !0,
    setFocused: function setFocused() {},
    setAddAfterBlockId: function setAddAfterBlockId() {},
    handleChange: function handleChange() {},
    handleAddBlockAfter: function handleAddBlockAfter() {},
    handleRemoveBlock: function handleRemoveBlock() {},
    handleSort: function handleSort() {}
  }));
},
    Me = function Me(e) {
  var r = e.focusedBlock,
      n = e.onChange,
      o = t.useState([]),
      a = o[0],
      i = o[1],
      l = t.useState({}),
      s = l[0],
      u = l[1],
      d = r.block,
      p = r.type;
  return t.useEffect(function () {
    p && p.sideEditProps && d ? function (e, t) {
      try {
        var r = e.map(function (e) {
          try {
            var t = function t(_t) {
              return r ? _t : {
                propName: e.name,
                options: []
              };
            },
                r = !1,
                n = function () {
              if (e.type === exports.types.SideEditPropType.Select && e.selectOptions && (e.selectOptions.options && e.selectOptions.options.length > 0 || "function" == typeof e.selectOptions.getOptions)) return Promise.resolve(function (e, t) {
                try {
                  if (e) return Promise.resolve(e);
                  if (!t) return Promise.resolve([]);
                  var r = t();
                  return Promise.resolve(r);
                } catch (e) {
                  return Promise.reject(e);
                }
              }(e.selectOptions.options, e.selectOptions.getOptions)).then(function (t) {
                return r = !0, {
                  propName: e.name,
                  options: t
                };
              });
            }();

            return Promise.resolve(n && n.then ? n.then(t) : t(n));
          } catch (e) {
            return Promise.reject(e);
          }
        });
        return Promise.all(r);
      } catch (e) {
        return Promise.reject(e);
      }
    }(p.sideEditProps).then(function (e) {
      var t = e.reduce(function (e, t) {
        return e[t.propName] = t.options, e;
      }, {});
      u(t);
    }) : u({});
  }, []), t.useEffect(function () {
    if (p && p.sideEditProps && d) {
      var e = p.sideEditProps.map(function (e) {
        var r,
            o = null,
            a = !0;
        if ("function" == typeof e.show && !e.show(d.props)) return null;

        if ("function" != typeof e.validate || e.validate(d.props[e.name], d.props) || (a = !1), e.type === exports.types.SideEditPropType.Text || e.type === exports.types.SideEditPropType.Number || e.type === exports.types.SideEditPropType.Date) {
          var i,
              l,
              u,
              p = "text",
              m = {};
          e.type === exports.types.SideEditPropType.Number && (p = "number", (null === (i = e.rangeOptions) || void 0 === i ? void 0 : i.min) && (m.min = e.rangeOptions.min), (null === (l = e.rangeOptions) || void 0 === l ? void 0 : l.max) && (m.max = e.rangeOptions.max), (null === (u = e.rangeOptions) || void 0 === u ? void 0 : u.step) && (m.step = e.rangeOptions.step)), e.type === exports.types.SideEditPropType.Date && (p = "date"), o = t.createElement("input", Object.assign({
            className: c("bg-white focus:outline-none border border-gray-300 rounded py-1 px-2 block w-full appearance-none", {
              "border-2 border-red-500": !a
            }),
            type: p,
            value: d.props[e.name] || ""
          }, m, {
            onChange: function onChange(t) {
              return n(e.name, t.target.value);
            }
          }));
        }

        return e.type === exports.types.SideEditPropType.Boolean && (o = t.createElement("label", {
          className: "text-sm text-gray-700"
        }, t.createElement("input", {
          className: "mr-2",
          type: "checkbox",
          checked: d.props[e.name],
          onChange: function onChange(t) {
            return n(e.name, t.target.checked);
          }
        }), e.label)), e.type === exports.types.SideEditPropType.Range && e.rangeOptions && (o = t.createElement("input", {
          type: "range",
          value: d.props[e.name],
          min: e.rangeOptions.min || 0,
          max: e.rangeOptions.max || 100,
          step: e.rangeOptions.step || 1,
          onChange: function onChange(t) {
            return n(e.name, parseInt(t.target.value, 10));
          }
        })), e.type === exports.types.SideEditPropType.Image && (o = t.createElement(ce, {
          containerClassName: "w-full",
          imageClassName: "object-cover",
          source: d.props[e.name],
          propName: e.name,
          onChange: n,
          alt: e.name,
          maxWidth: null === (r = e.imageOptions) || void 0 === r ? void 0 : r.maxWidth
        })), e.type === exports.types.SideEditPropType.Select && e.selectOptions && e.selectOptions.display === exports.types.OptionsDisplay.Select && (e.selectOptions.options && e.selectOptions.options.length > 0 || "function" == typeof e.selectOptions.getOptions) && (o = t.createElement("div", {
          className: "relative"
        }, t.createElement("select", {
          className: "block appearance-none w-full bg-gray-300 border border-gray-300 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500",
          value: d.props[e.name],
          onChange: function onChange(t) {
            return n(e.name, t.target.value);
          }
        }, (s[e.name] || []).map(function (e) {
          return t.createElement("option", {
            key: e.value,
            value: e.value
          }, e.label);
        })), t.createElement("div", {
          className: "pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
        }, t.createElement("svg", {
          className: "fill-current h-4 w-4",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 20 20"
        }, t.createElement("path", {
          d: "M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
        }))))), e.type === exports.types.SideEditPropType.Select && e.selectOptions && e.selectOptions.display === exports.types.OptionsDisplay.Radio && (e.selectOptions.options && e.selectOptions.options.length > 0 || "function" == typeof e.selectOptions.getOptions) && (o = t.createElement("div", null, (s[e.name] || []).map(function (r) {
          return t.createElement("label", {
            className: "block text-sm text-gray-700",
            htmlFor: r.value,
            key: r.value
          }, t.createElement("input", {
            className: "mr-2",
            type: "radio",
            id: r.value,
            key: r.value,
            name: r.value,
            value: r.value,
            checked: d.props[e.name] === r.value,
            onChange: function onChange(t) {
              return n(e.name, t.target.value);
            }
          }), r.label);
        }))), e.type === exports.types.SideEditPropType.Select && e.selectOptions && e.selectOptions.display === exports.types.OptionsDisplay.Color && (e.selectOptions.options && e.selectOptions.options.length > 0 || "function" == typeof e.selectOptions.getOptions) && (o = t.createElement("div", null, (s[e.name] || []).map(function (r) {
          return t.createElement("div", {
            title: r.label,
            key: r.value,
            className: c("inline-block mr-2 border-2", {
              "border-pink-400": d.props[e.name] === r.value
            }, {
              "border-1 border-gray-400": d.props[e.name] !== r.value
            })
          }, t.createElement("div", {
            className: "w-8 h-8 cursor-pointer",
            style: {
              backgroundColor: r.value
            },
            onClick: function onClick() {
              return n(e.name, r.value);
            }
          }));
        }))), t.createElement("div", {
          className: "mb-6",
          key: e.name
        }, t.createElement("h3", {
          className: c("text-xs font-bold uppercase tracking-wider text-gray-600 mb-1", {
            "text-red-500": !a
          })
        }, e.label), o);
      });
      i(e);
    } else i(null);
  }, [null == p ? void 0 : p.sideEditProps, null == d ? void 0 : d.props, s]), t.createElement("div", {
    className: "knobs"
  }, a);
},
    qe = function qe(e) {
  var r = e.addAfterBlockId,
      n = e.handleChange,
      o = e.handleAddBlock,
      a = e.handleAddItem,
      i = e.handleRemoveItem,
      l = e.handlePreviewNewBlock,
      c = e.focused,
      s = e.focusedBlock,
      u = e.focusedBlockType,
      d = e.focusedBlockTypeName,
      p = e.focusedItem,
      g = e.focusedItemType,
      f = e.focusedItemTypeName,
      b = t.useContext(_).blockTypeSchema,
      y = t.useState(""),
      h = y[0],
      x = y[1],
      v = t.useRef(null),
      k = function k() {
    l(null), clearTimeout(v.current);
  };

  return t.createElement(t.Fragment, null, c.blockId ? t.createElement(t.Fragment, null, t.createElement("h2", {
    className: "text-sm font-bold uppercase tracking-wider text-gray-600 mb-6"
  }, d), t.createElement(Me, {
    focusedBlock: {
      block: s,
      type: u
    },
    onChange: n(c.blockId, "")
  })) : !r && t.createElement("h2", {
    className: "text-sm font-bold uppercase tracking-wider text-gray-600 mb-6"
  }, "Select a block to edit"), !!u && u.superType === exports.types.BlockSuperType.Repeater && t.createElement(t.Fragment, null, t.createElement("button", {
    className: "block bg-pink-500 hover:bg-pink-600 hover:shadow-lg text-white font-bold py-2 px-4 rounded mb-12",
    onClick: a(c.blockId, u.itemsType || "")
  }, u.addItemText), c.itemId && t.createElement(t.Fragment, null, t.createElement("h2", {
    className: "text-sm font-bold uppercase tracking-wider text-gray-600 mb-6"
  }, f), t.createElement(Me, {
    focusedBlock: {
      block: p,
      type: g
    },
    onChange: n(c.itemId, c.blockId)
  }), t.createElement("button", {
    className: "block bg-white border hover:shadow-lg font-semibold py-1 px-4 rounded",
    onClick: i(c.blockId, c.itemId)
  }, t.createElement("span", {
    className: "mr-1",
    style: {
      color: "#c00"
    }
  }, "×"), u.removeItemText))), r && t.createElement("div", null, t.createElement("div", {
    className: "relative mb-4"
  }, t.createElement("input", {
    type: "text",
    value: h,
    onChange: function onChange(e) {
      x(e.target.value);
    },
    className: "py-2 px-4 pr-8 leading-none w-full border border-gray-200 rounded-full outline-none",
    placeholder: "Search block type..."
  }), t.createElement(m.FiSearch, {
    className: "absolute text-gray-400",
    style: {
      top: 9,
      right: 11
    }
  })), b.filter(function (e) {
    return !e.hideFromAddMenu && e.name.toLowerCase().indexOf(h.toLowerCase()) > -1;
  }).map(function (e) {
    return t.createElement("button", {
      key: e.name,
      className: "block w-full bg-white border border-gray-500 text-gray-600 hover:text-pink-600 hover:bg-pink-100 hover:border-pink-400 hover:shadow-lg hover:text-white font-bold py-2 px-4 rounded mb-3",
      onClick: o(e.name),
      onMouseOver: (r = e.name, function () {
        v.current = setTimeout(function () {
          return l(r);
        }, 700);
      }),
      onMouseOut: k
    }, e.label);
    var r;
  })));
},
    Ue = require("react-query").useMutation,
    He = require("react-query").queryCache,
    We = require("react-query").useMutation,
    Qe = require("react-query").queryCache,
    _e = require("react-query").useMutation,
    Ke = require("react-query").queryCache,
    Ge = ["aa", "ab", "ae", "af", "ak", "am", "an", "ar", "as", "av", "ay", "az", "ba", "be", "bg", "bh", "bi", "bm", "bn", "bo", "br", "bs", "ca", "ce", "ch", "co", "cr", "cs", "cu", "cv", "cy", "da", "de", "dv", "dz", "ee", "el", "en", "eo", "es", "et", "eu", "fa", "ff", "fi", "fj", "fo", "fr", "fy", "ga", "gd", "gl", "gn", "gu", "gv", "ha", "he", "hi", "ho", "hr", "ht", "hu", "hy", "hz", "ia", "id", "ie", "ig", "ii", "ik", "io", "is", "it", "iu", "ja", "jv", "ka", "kg", "ki", "kj", "kk", "kl", "km", "kn", "ko", "kr", "ks", "ku", "kv", "kw", "ky", "la", "lb", "lg", "li", "ln", "lo", "lt", "lu", "lv", "mg", "mh", "mi", "mk", "ml", "mn", "mr", "ms", "mt", "my", "na", "nb", "nd", "ne", "ng", "nl", "nn", "no", "nr", "nv", "ny", "oc", "oj", "om", "or", "os", "pa", "pi", "pl", "ps", "pt", "qu", "rm", "rn", "ro", "ru", "rw", "sa", "sc", "sd", "se", "sg", "si", "sk", "sl", "sm", "sn", "so", "sq", "sr", "ss", "st", "su", "sv", "sw", "ta", "te", "tg", "th", "ti", "tk", "tl", "tn", "to", "tr", "ts", "tt", "tw", "ty", "ug", "uk", "ur", "uz", "ve", "vi", "vo", "wa", "wo", "xh", "yi", "yo", "za", "zh", "zu"],
    Je = function Je(e) {
  var r = e.options,
      n = e.value,
      o = e.onChange,
      a = e.alignRight,
      i = void 0 !== a && a,
      l = t.useState(!1),
      c = l[0],
      s = l[1],
      u = t.useCallback(function () {
    s(!1);
  }, []);
  t.useEffect(function () {
    c ? document.addEventListener("click", u) : document.removeEventListener("click", u);
  }, [c, u]);
  var d = r.find(function (e) {
    return e.value === n;
  });
  return t.createElement("div", {
    className: "relative text-sm text-gray-600"
  }, t.createElement("button", {
    className: "flex flex-row items-center hover:text-gray-800 focus:outline-none focus:text-gray-800",
    onClick: function onClick(e) {
      e.preventDefault(), s(!0);
    }
  }, null == d ? void 0 : d.icon, " ", null == d ? void 0 : d.label, t.createElement(m.FiChevronDown, {
    className: "inline-block"
  })), c ? t.createElement("div", {
    className: "menu absolute " + (i ? "right-0" : "left-0") + " mt-1 py-2 bg-white shadow-lg rouded z-10"
  }, r.map(function (e) {
    return t.createElement("button", {
      key: e.value,
      className: "flex flex-row items-center py-1 pl-4 pr-5 hover:text-gray-800",
      onClick: function onClick() {
        return o(e.value);
      }
    }, e.icon, e.label);
  })) : null);
},
    Ve = function Ve(e) {
  var r,
      n = e.page,
      o = ze(n.id)[0],
      a = (r = n.id, Ue(function (e) {
    var t = e.tag;
    return ae(re + "/pages/" + r + "/tags", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(ne),
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        name: t
      })
    });
  }, {
    onSuccess: function onSuccess(e) {
      He.refetchQueries(["page", {
        pageId: r
      }]), 423 === e.statusCode ? s.warn("Creating tags not allowed on this demo", {
        position: "bottom-right"
      }) : e.statusCode && s.error("An error occurred while adding the tag", {
        position: "bottom-right"
      });
    },
    onError: function onError() {
      s.error("An error occurred while adding the tag", {
        position: "bottom-right"
      });
    }
  }))[0],
      i = function (e) {
    return We(function (t) {
      return ae(re + "/pages/" + e + "/tags/" + t.tag, {
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + localStorage.getItem(ne),
          "Content-Type": "application/json"
        }
      });
    }, {
      onSuccess: function onSuccess(t) {
        Qe.refetchQueries(["page", {
          pageId: e
        }]), 423 === t.statusCode ? s.warn("Removing tags not allowed on this demo", {
          position: "bottom-right"
        }) : t.statusCode && s.error("An error occurred while removing the tag", {
          position: "bottom-right"
        });
      },
      onError: function onError() {
        s.error("An error occurred while removing the tag", {
          position: "bottom-right"
        });
      }
    });
  }(n.id)[0],
      l = _e(function (e) {
    return ae(re + "/pages/" + e.pageId, {
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(ne)
      }
    });
  }, {
    onSuccess: function onSuccess(e) {
      Ke.refetchQueries("pages"), 423 === e.statusCode || 423 === e.status ? s.warn("Deleting not allowed on this demo", {
        position: "bottom-right"
      }) : e.statusCode ? s.error("An error occurred while deleting the page", {
        position: "bottom-right"
      }) : s.success("Page deleted", {
        position: "bottom-right"
      });
    },
    onError: function onError() {
      s.error("An error occurred while deleting the page", {
        position: "bottom-right"
      });
    }
  })[0],
      c = t.useContext(k),
      u = c.user,
      d = c.setCurrentPage,
      p = t.useContext(_).pageTypeSchema,
      g = t.useState(!1),
      f = g[0],
      b = g[1],
      v = p.find(function (e) {
    return e.name === n.type;
  }),
      E = function E(e) {
    return function (t) {
      var r;
      o({
        pageId: n.id,
        page: w({}, n, {
          meta: w({}, n.meta, (r = {}, r[e] = t, r))
        })
      }, {
        updateQuery: ["page", {
          pageId: n.id
        }]
      });
    };
  },
      C = [{
    value: !1,
    label: "Draft",
    icon: t.createElement(m.FiEyeOff, {
      className: "inline-block text-gray-400",
      style: {
        marginRight: 6
      }
    })
  }, {
    value: !0,
    label: "Published",
    icon: t.createElement(m.FiEye, {
      className: "inline-block text-pink-400",
      style: {
        marginRight: 6
      }
    })
  }],
      N = [{
    value: !1,
    label: "Unlocked",
    icon: t.createElement(m.FiUnlock, {
      className: "inline-block text-gray-400",
      style: {
        marginRight: 6
      }
    })
  }, {
    value: !0,
    label: "Locked",
    icon: t.createElement(m.FiLock, {
      className: "inline-block text-pink-400",
      style: {
        marginRight: 6
      }
    })
  }];

  return t.createElement(t.Fragment, null, t.createElement("div", {
    className: "mb-6 flex flex-row justify-between"
  }, t.createElement(Je, {
    value: n.status === exports.types.PageStatus.Published,
    options: C,
    onChange: function onChange(e) {
      o({
        pageId: n.id,
        page: w({}, n, {
          status: e ? exports.types.PageStatus.Published : exports.types.PageStatus.Draft
        })
      }, {
        updateQuery: ["page", {
          pageId: n.id
        }]
      });
    }
  }), u && u.isAdmin && t.createElement(Je, {
    value: n.isLocked,
    options: N,
    onChange: function onChange(e) {
      o({
        pageId: n.id,
        page: w({}, n, {
          isLocked: e
        })
      }, {
        updateQuery: ["page", {
          pageId: n.id
        }]
      });
    },
    alignRight: !0
  })), t.createElement("div", {
    className: "mb-6"
  }, t.createElement("h3", {
    className: "text-xs font-bold uppercase tracking-wider text-gray-600 mb-1"
  }, "Title"), t.createElement("div", {
    className: "relative"
  }, t.createElement(x, {
    type: h.InputType.Text,
    value: n.name || "new page",
    onChange: function onChange(e) {
      o({
        pageId: n.id,
        page: w({}, n, {
          name: e
        })
      }, {
        updateQuery: ["page", {
          pageId: n.id
        }]
      });
    },
    viewClass: "block text-gray-800 truncate",
    editClass: "px-1 -ml-1 focus:outline-none rounded",
    validate: function validate(e) {
      return e.length > 0;
    },
    invalidClass: "border border-red-500"
  }))), t.createElement("div", {
    className: "mb-6"
  }, t.createElement("h3", {
    className: "text-xs font-bold uppercase tracking-wider text-gray-600 mb-2"
  }, "Slug"), t.createElement("div", {
    className: "relative"
  }, t.createElement(x, {
    type: h.InputType.Text,
    value: n.slug || "new-page",
    onChange: function onChange(e) {
      o({
        pageId: n.id,
        page: w({}, n, {
          slug: e
        })
      }, {
        updateQuery: ["page", {
          pageId: n.id
        }]
      });
    },
    viewClass: "block text-gray-800 truncate",
    editClass: "px-1 -ml-1 focus:outline-none rounded",
    validate: function validate(e) {
      return new RegExp(/^[A-Za-z0-9\-_]+$/).test(e);
    },
    invalidClass: "border border-red-500"
  }))), t.createElement("div", {
    className: "mb-6"
  }, t.createElement("h3", {
    className: "text-xs font-bold uppercase tracking-wider text-gray-600 mb-1"
  }, "Page Type"), t.createElement("div", {
    className: "relative"
  }, t.createElement(x, {
    type: h.InputType.Select,
    value: n.type || "",
    onChange: function onChange(e) {
      o({
        pageId: n.id,
        page: w({}, n, {
          type: e
        })
      }, {
        updateQuery: ["page", {
          pageId: n.id
        }]
      });
    },
    options: p.map(function (e) {
      return {
        value: e.name,
        label: e.name
      };
    }),
    viewClass: "block text-gray-800",
    editClass: "px-1 -ml-1 focus:text-gray-800 rounded leading-tight focus:outline-none focus:bg-white focus:border focus:border-gray-500"
  }))), t.createElement("div", {
    className: "mb-6"
  }, t.createElement("h3", {
    className: "text-xs font-bold uppercase tracking-wider text-gray-600 mb-1"
  }, "Tags"), t.createElement("div", {
    className: "relative"
  }, n.tags && t.createElement(x, {
    type: h.InputType.Text,
    value: "Add a new tag",
    onChange: function onChange(e) {
      return a({
        tag: e
      });
    },
    viewClass: "block text-gray-800 italic",
    editClass: "px-1 -ml-1 focus:outline-none rounded",
    validate: function validate(e) {
      return new RegExp(/^[A-Za-z0-9\-_]+$/).test(e);
    },
    invalidClass: "border border-red-500",
    optimisticUpdate: !1,
    saveTimeout: 10,
    errorDuration: 10
  }), n.tags.map(function (e) {
    return t.createElement("div", {
      key: e,
      className: "inline-block px-2 bg-blue-200 text-blue-800 border border-blue-300 rounded-lg mr-2 mt-2"
    }, e, " ", t.createElement("button", {
      className: "text-blue-400 hover:text-red-500 ml-1",
      onClick: function onClick() {
        return i({
          tag: e
        });
      }
    }, "×"));
  }))), t.createElement("button", {
    onClick: function onClick() {
      return b(!f);
    },
    className: "text-pink-600 hover:text-pink-700 mb-6 flex items-center"
  }, f ? "Hide" : "Show", " SEO fields", " ", t.createElement(f ? m.FiChevronUp : m.FiChevronDown, {
    className: "ml-1"
  })), !!f && t.createElement(t.Fragment, null, t.createElement("div", {
    className: "mb-6"
  }, t.createElement("h3", {
    className: "text-xs font-bold uppercase tracking-wider text-gray-600 mb-1"
  }, "SEO Title"), t.createElement("div", {
    className: "relative"
  }, t.createElement(x, {
    type: h.InputType.Text,
    value: n.meta.title || "No title",
    onChange: E("title"),
    viewClass: "block text-gray-800 truncate",
    editClass: "px-1 -ml-1 focus:outline-none rounded"
  }))), t.createElement("div", {
    className: "mb-6"
  }, t.createElement("h3", {
    className: "text-xs font-bold uppercase tracking-wider text-gray-600 mb-1"
  }, "SEO Description"), t.createElement("div", {
    className: "relative"
  }, t.createElement(x, {
    type: h.InputType.TextArea,
    value: n.meta.description || "No description",
    onChange: E("description"),
    viewClass: "block text-gray-800 truncate",
    editClass: "px-1 -ml-1 focus:outline-none rounded",
    showNewLines: !1
  }))), t.createElement("div", {
    className: "mb-6"
  }, t.createElement("h3", {
    className: "text-xs font-bold uppercase tracking-wider text-gray-600 mb-1"
  }, "Language"), t.createElement("div", {
    className: "relative"
  }, t.createElement(x, {
    type: h.InputType.Select,
    value: n.meta.language || (null == v ? void 0 : v.defaultLanguage) || "en",
    onChange: E("language"),
    options: Ge.map(function (e) {
      return {
        value: e,
        label: e
      };
    }),
    viewClass: "block text-gray-800",
    editClass: "px-1 -ml-1 focus:text-gray-800 rounded leading-tight focus:outline-none focus:bg-white focus:border focus:border-gray-500"
  })))), t.createElement("button", {
    className: "block w-full py-1 uppercase text-sm text-pink-500 border border-pink-500 hover:border-pink-600 hover:text-pink-600 hover:shadow-lg rounded",
    onClick: function onClick(e) {
      try {
        return e.preventDefault(), Promise.resolve(l({
          pageId: n.id
        })).then(function () {
          d("");
        });
      } catch (e) {
        return Promise.reject(e);
      }
    }
  }, "Delete document"), u && u.isAdmin && t.createElement(y, {
    text: JSON.stringify(n.content)
  }, t.createElement("a", {
    href: "#",
    className: "flex flex-row justify-start items-center my-6 text-gray-600 hover:text-gray-800 text-sm"
  }, t.createElement(m.FiCopy, {
    className: "mr-2"
  }), " Copy content to clipboard")));
},
    Xe = function Xe(e) {
  var r = e.blockTypeName,
      n = t.useContext(_).pageTypeSchema;
  if (!r) return null;
  var o = n.filter(function (e) {
    return Te(r, e.allowedBlockTypes, e.excludedBlockTypes);
  }).map(function (e) {
    return e.name;
  }),
      a = n.filter(function (e) {
    return !Te(r, e.allowedBlockTypes, e.excludedBlockTypes);
  }).map(function (e) {
    return e.name;
  });
  return t.createElement("div", null, o.length > 0 && t.createElement(t.Fragment, null, t.createElement("h3", {
    className: "text-xs font-bold uppercase tracking-wider text-gray-600 mb-1"
  }, "Allowed in"), t.createElement("div", {
    className: "flex flex-row flex-wrap mb-5"
  }, o.map(function (e) {
    return t.createElement("div", {
      className: "flex items-center py-1 px-3 bg-gray-500 text-white text-sm uppercase leading-none rounded mr-2 mb-1"
    }, e);
  }))), a.length > 0 && t.createElement(t.Fragment, null, t.createElement("h3", {
    className: "text-xs font-bold uppercase tracking-wider text-gray-600 mb-1"
  }, "Excluded from"), t.createElement("div", {
    className: "flex flex-row flex-wrap"
  }, a.map(function (e) {
    return t.createElement("div", {
      className: "flex items-center py-1 px-3 bg-gray-500 text-white text-sm uppercase leading-none rounded mr-2 mb-1"
    }, e);
  }))));
},
    Ye = function Ye(e) {
  var r = e.pageTypeName,
      n = t.useContext(_),
      o = n.blockTypeSchema;
  if (!r) return null;
  var a = n.pageTypeSchema.find(function (e) {
    return e.name === r;
  });
  if (!a) return null;
  var i = o.filter(function (e) {
    return !e.hideFromAddMenu && Te(e.name, a.allowedBlockTypes, a.excludedBlockTypes);
  }).map(function (e) {
    return e.label;
  }),
      l = o.filter(function (e) {
    return !e.hideFromAddMenu && !Te(e.name, a.allowedBlockTypes, a.excludedBlockTypes);
  }).map(function (e) {
    return e.label;
  });
  return t.createElement("div", null, t.createElement("h3", {
    className: "text-xs font-bold uppercase tracking-wider text-gray-600 mb-1"
  }, "Default status"), t.createElement("div", {
    className: "flex flex-row mb-5"
  }, t.createElement("div", {
    className: "flex-1 flex items-center py-1 px-3 bg-gray-500 text-white text-sm uppercase leading-none rounded mr-2 mb-1"
  }, a.defaultStatus), t.createElement("div", {
    className: "flex-1 flex items-center py-1 px-3 bg-gray-500 text-white text-sm uppercase leading-none rounded mr-2 mb-1"
  }, a.defaultLocked ? "LOCKED" : "UNLOCKED")), i.length > 0 && t.createElement(t.Fragment, null, t.createElement("h3", {
    className: "text-xs font-bold uppercase tracking-wider text-gray-600 mb-1"
  }, "Allowed blocks"), t.createElement("div", {
    className: "flex flex-row flex-wrap mb-5"
  }, i.map(function (e) {
    return t.createElement("div", {
      className: "flex items-center py-1 px-3 bg-gray-500 text-white text-sm uppercase leading-none rounded mr-2 mb-1"
    }, e);
  }))), l.length > 0 && t.createElement(t.Fragment, null, t.createElement("h3", {
    className: "text-xs font-bold uppercase tracking-wider text-gray-600 mb-1"
  }, "Blocks excluded"), t.createElement("div", {
    className: "flex flex-row flex-wrap"
  }, l.map(function (e) {
    return t.createElement("div", {
      className: "flex items-center py-1 px-3 bg-gray-500 text-white text-sm uppercase leading-none rounded mr-2 mb-1"
    }, e);
  }))));
},
    $e = function $e(e) {
  var r = e.page,
      n = e.content,
      o = e.focused,
      a = e.addAfterBlockId,
      i = e.handleChange,
      l = e.handleAddBlock,
      c = e.handleAddItem,
      s = e.handleRemoveItem,
      u = e.handlePreviewNewBlock,
      d = e.playgroundSelectedItem,
      p = t.useContext(_).blockTypeSchema,
      m = t.useContext(k).previewMode,
      g = o.blockId ? n.find(function (e) {
    return e.id === o.blockId;
  }) : null,
      f = g ? g.type : "",
      b = p.find(function (e) {
    return e.name === f;
  }),
      y = null,
      h = "",
      x = null;
  o.itemId && g && (y = g.props.items.find(function (e) {
    return e.id === o.itemId;
  })) && (h = y.type, x = p.find(function (e) {
    return e.name === h;
  }));
  var v = t.useState("block"),
      E = v[0],
      w = v[1];
  t.useEffect(function () {
    w("block");
  }, [r.id]);

  var C = function C(e, r) {
    return t.createElement("button", {
      className: "flex-1 py-1 text-center border-b-4 focus:outline-none hover:text-gray-800 " + (E === e ? "border-pink-400 text-gray-800" : "border-transparent text-gray-600"),
      style: {
        marginBottom: "-1px"
      },
      onClick: function onClick() {
        return w(e);
      }
    }, r);
  };

  return t.createElement("aside", {
    className: m ? "w-0" : "w-64",
    style: {
      transition: "width 300ms"
    }
  }, !m && t.createElement("div", {
    className: "fixed top-0 h-full pt-24 pl-4 w-64 overflow-y-auto",
    style: {
      right: 24
    }
  }, r.invalidBlocksTypes && r.invalidBlocksTypes.length > 0 && t.createElement("div", {
    className: "border border-pink-400 bg-pink-100 rounded px-2 py-1 mb-3 text-sm leading-tight"
  }, t.createElement("b", null, "Warning:"), " found ", r.invalidBlocksTypes.length, " ", r.invalidBlocksTypes.length > 1 ? "blocks" : "block", " of unrecognized or not allowed type:", r.invalidBlocksTypes.map(function (e) {
    return t.createElement("code", {
      key: e,
      className: "ml-1 text-xs px-1 py-px bg-pink-200 rounded"
    }, e);
  }), ". Saving will delete invalid blocks."), t.createElement("div", {
    className: "flex flex-row items-center justify-around mb-6 border-b"
  }, C("block", d && d.type === exports.types.PlaygroundSelectedItemType.Block ? "Props edit" : "Block"), !d && C("document", "Document"), (null == d ? void 0 : d.type) === exports.types.PlaygroundSelectedItemType.Block && C("allowed-in", "Allowed in"), (null == d ? void 0 : d.type) === exports.types.PlaygroundSelectedItemType.Page && C("page-settings", "Page settings")), "block" === E && t.createElement(qe, {
    addAfterBlockId: a,
    handleChange: i,
    handleAddBlock: l,
    handleAddItem: c,
    handleRemoveItem: s,
    handlePreviewNewBlock: u,
    focused: o,
    focusedBlock: g,
    focusedBlockType: b,
    focusedBlockTypeName: f,
    focusedItem: y,
    focusedItemType: x,
    focusedItemTypeName: h
  }), "document" === E && t.createElement(Ve, {
    page: r
  }), "allowed-in" === E && t.createElement(Xe, {
    blockTypeName: null == d ? void 0 : d.name
  }), "page-settings" === E && t.createElement(Ye, {
    pageTypeName: null == d ? void 0 : d.name
  })));
},
    Ze = function Ze(e) {
  var r = e.page,
      n = e.content,
      o = e.onChange,
      a = e.locked,
      i = void 0 !== a && a,
      l = e.playgroundSelectedItem,
      c = t.useContext(_),
      s = c.blockTypeSchema,
      u = c.contentClassName,
      d = t.useContext(k),
      p = d.currentPage,
      g = d.previewMode,
      b = d.getStyles,
      y = d.getStylesheets,
      h = t.useState({
    blockId: "",
    itemId: ""
  }),
      x = h[0],
      v = h[1],
      E = t.useState(""),
      C = E[0],
      N = E[1],
      S = t.useState(null),
      T = S[0],
      L = S[1],
      I = t.useState([]),
      P = I[0],
      B = I[1],
      O = t.useState([]),
      z = O[0],
      A = O[1];
  t.useEffect(function () {
    v({
      blockId: "",
      itemId: ""
    }), N(""), setTimeout(function () {
      B(b()), A(y());
    }, 600);
  }, [p]);

  var j = function j(e, t) {
    return function (r, a) {
      var i;
      i = n.map(t ? function (t) {
        return t.props.items ? w({}, t, {
          props: w({}, t.props, {
            items: t.props.items.map(function (t) {
              var n;
              return t.id === e ? w({}, t, {
                props: w({}, t.props, (n = {}, n[r] = a, n))
              }) : t;
            })
          })
        }) : t;
      } : function (t) {
        var n;
        return t.id === e ? w({}, t, {
          props: w({}, t.props, (n = {}, n[r] = a, n))
        }) : t;
      }), o(i);
    };
  },
      D = function D(e) {
    return function (t) {
      t.preventDefault(), v({
        blockId: "",
        itemId: ""
      }), N(e);
    };
  },
      F = function F(e, t) {
    return function (r) {
      r.preventDefault();
      var a = [].concat(n),
          i = a.findIndex(function (t) {
        return t.id === e;
      });

      if (t === exports.types.SortDirection.Up) {
        var l = a[i - 1];
        a[i - 1] = a[i], a[i] = l;
      } else {
        var c = a[i + 1];
        a[i + 1] = a[i], a[i] = c;
      }

      o(a);
    };
  },
      R = function R(e) {
    return function (t) {
      t.preventDefault(), v({
        blockId: "",
        itemId: ""
      });
      var r = n.filter(function (t) {
        return t.id !== e;
      });
      o(r);
    };
  };

  return t.createElement("div", {
    className: "flex flex-1 flex-row"
  }, t.createElement(xe, {
    id: "rb-content-frame",
    className: "flex-1 h-screen",
    style: {
      marginTop: 52
    },
    styles: P,
    stylesheets: z
  }, t.createElement("div", {
    style: {
      paddingTop: 22,
      paddingLeft: 10,
      paddingRight: 10,
      paddingBottom: 100
    }
  }, t.createElement("div", {
    style: {
      backgroundColor: "#fff",
      position: "relative",
      boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)"
    }
  }, !i && !g && t.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: 10
    }
  }, t.createElement("div", {
    style: {
      boxSizing: "border-box",
      padding: 4,
      backgroundColor: "#fff",
      borderRadius: 100,
      width: 26,
      height: 26,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: 18,
      color: "#f65a8e"
    }
  }, t.createElement("button", {
    className: "rb-action"
  }, t.createElement(m.FiPlusCircle, {
    onClick: D("FIRST")
  })))), "FIRST" === C && t.createElement(Re, {
    previewNewBlock: T
  }), t.createElement("div", {
    className: "react-bricks-content " + u
  }, n.map(function (e, r) {
    return t.createElement(t.Fragment, {
      key: e.id
    }, t.createElement(Fe, {
      contentLength: n.length,
      block: e,
      index: r,
      focused: x,
      locked: i,
      setFocused: v,
      setAddAfterBlockId: N,
      handleChange: j,
      handleAddBlockAfter: D,
      handleRemoveBlock: R,
      handleSort: F
    }), C === e.id && t.createElement(Re, {
      previewNewBlock: T
    }));
  }))))), !g && t.createElement($e, {
    page: r,
    content: n,
    focused: x,
    addAfterBlockId: C,
    handleChange: j,
    handleAddBlock: function handleAddBlock(e) {
      return function (t) {
        t.preventDefault();
        var r = f.v4(),
            a = s.find(function (t) {
          return t.name === e;
        });

        if (a) {
          var i,
              l = {
            id: r,
            type: e,
            props: a.getDefaultProps()
          };
          i = "FIRST" === C ? [l].concat(n) : n.reduce(function (e, t) {
            return [].concat(e, t.id === C ? [t, l] : [t]);
          }, []), o(i), N(""), v({
            blockId: r,
            itemId: ""
          });
        }
      };
    },
    handleAddItem: function handleAddItem(e, t) {
      return function () {
        var r = s.find(function (e) {
          return e.name === t;
        });

        if (r) {
          var a = {
            id: f.v4(),
            type: t,
            props: r.getDefaultProps()
          },
              i = n.map(function (t) {
            return t.id === e ? w({}, t, {
              props: w({}, t.props, {
                items: [].concat(t.props.items, [a])
              })
            }) : t;
          });
          o(i);
        }
      };
    },
    handleRemoveItem: function handleRemoveItem(e, t) {
      return function () {
        var r = n.map(function (r) {
          return r.id === e ? w({}, r, {
            props: w({}, r.props, {
              items: r.props.items.filter(function (e) {
                return e.id !== t;
              })
            })
          }) : r;
        });
        v({
          blockId: x.blockId,
          itemId: ""
        }), o(r);
      };
    },
    handlePreviewNewBlock: function handlePreviewNewBlock(e) {
      e || L(null);
      var t = s.find(function (t) {
        return t.name === e;
      });

      if (t) {
        var r = {
          id: "PREVIEW_NEW",
          type: e,
          props: t.getDefaultProps()
        };
        L(r);
      }
    },
    playgroundSelectedItem: l
  }));
},
    et = function et() {
  var e = t.useContext(_),
      r = e.blockTypeSchema,
      n = e.pageTypeSchema,
      o = t.useContext(k).currentPage,
      a = Se(o).data,
      i = t.useState(Le),
      l = i[0],
      c = i[1];
  return t.useEffect(function () {
    c(a ? Ie(a, n, r) : Le);
  }, [a]), t.createElement("div", {
    className: "flex-1"
  }, !!o && l && t.createElement(t.Fragment, null, t.createElement(De, {
    page: l
  }), t.createElement(Ze, {
    page: l,
    content: l.content,
    onChange: function onChange(e) {
      c(w({}, l, {
        content: e
      }));
    },
    locked: l.isLocked
  })));
},
    tt = function tt(e) {
  var r = e.schema,
      n = e.block;
  return t.createElement("div", {
    key: n.id
  }, function (e) {
    var t = r.find(function (t) {
      return t.name === e.type;
    });

    if (t) {
      var n = null;
      t.superType === exports.types.BlockSuperType.Repeater && (n = e.props.items.map(function (e) {
        return e.type !== t.itemsType ? null : function (e) {
          var t = r.find(function (t) {
            return t.name === e.type;
          });

          if (t) {
            var n = w({}, e.props, {
              key: e.id
            });
            return t.render(n);
          }
        }(e);
      }));
      var o = w({}, e.props);
      return t.superType === exports.types.BlockSuperType.Repeater && (o.renderItems = n), t.render(o);
    }
  }(n));
},
    rt = function rt(e) {
  var r = e.schema;
  return t.createElement("div", null, e.content.map(function (e) {
    return t.createElement(tt, {
      key: e.id,
      schema: r,
      block: e
    });
  }));
},
    nt = function nt(e) {
  var n = e.pageId,
      o = t.useContext(_),
      a = o.navigate,
      i = o.editorPath;
  if ("undefined" == typeof localStorage) return null;
  var l = localStorage.getItem(ne);
  return l && l.length > 10 && l.startsWith("ey") ? r.createElement("div", {
    style: {
      position: "fixed",
      bottom: 20,
      right: 20,
      width: 36,
      height: 36,
      borderRadius: 999,
      backgroundColor: "#f65a8e",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: "#fff",
      fontSize: 18,
      cursor: "pointer",
      boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)"
    },
    onClick: function onClick() {
      return a(i + "?p=" + encodeURIComponent(n));
    }
  }, r.createElement(m.FiEdit, null)) : null;
},
    ot = t.createContext({
  selectedItem: null,
  setSelectedItem: function setSelectedItem() {}
}),
    at = function at() {
  var e = t.useContext(_),
      r = e.pageTypeSchema,
      n = e.blockTypeSchema,
      o = t.useContext(k),
      a = o.previewMode,
      i = o.sidebarCollapsed,
      l = t.useContext(ot),
      s = l.selectedItem,
      u = l.setSelectedItem;
  return t.createElement("div", {
    style: {
      width: a || i ? 0 : 220,
      transition: "width 300ms"
    }
  }, !a && !i && t.createElement("div", {
    className: "fixed w-48 h-full overflow-y-auto scrolling-touch pr-4"
  }, t.createElement("nav", {
    className: "overflow-y-auto pb-24"
  }, t.createElement("div", {
    className: "mt-4 mb-4"
  }, t.createElement("div", {
    className: "flex flex-row justify-between items-center border-b border-gray-300 pb-1 mb-2"
  }, t.createElement("h3", {
    className: "w-full text-xs leading-none font-bold uppercase tracking-wider text-gray-600"
  }, "Block Types")), t.createElement("ul", {
    className: "pb-4"
  }, n.filter(function (e) {
    return !e.hideFromAddMenu;
  }).map(function (e) {
    return t.createElement("li", {
      key: e.name,
      onClick: function onClick() {
        return u({
          type: exports.types.PlaygroundSelectedItemType.Block,
          name: e.name,
          label: e.label
        });
      },
      className: c("text-sm px-1 py-px mb-1 flex flex-row justify-between items-center text-gray-600 hover:text-gray-800 cursor-pointer", {
        "bg-white rounded text-pink-700 hover:text-pink-700": (null == s ? void 0 : s.type) === exports.types.PlaygroundSelectedItemType.Block && (null == s ? void 0 : s.name) === e.name
      })
    }, t.createElement("div", {
      className: "flex flex-row justify-start items-center flex-1"
    }, t.createElement("div", {
      className: c("mr-2", "text-gray-400", {
        "text-pink-300": (null == s ? void 0 : s.type) === exports.types.PlaygroundSelectedItemType.Block && (null == s ? void 0 : s.name) === e.name
      })
    }, e.superType === exports.types.BlockSuperType.Repeater ? t.createElement(m.FiGrid, null) : t.createElement(m.FiBox, null)), t.createElement("div", null, e.label)));
  })), t.createElement("div", {
    className: "flex flex-row justify-between items-center border-b border-gray-300 pb-1 mb-2"
  }, t.createElement("h3", {
    className: "w-full text-xs leading-none font-bold uppercase tracking-wider text-gray-600"
  }, "Page Types")), t.createElement("ul", null, r.map(function (e) {
    return t.createElement("li", {
      key: e.name,
      onClick: function onClick() {
        return u({
          type: exports.types.PlaygroundSelectedItemType.Page,
          name: e.name,
          label: e.name
        });
      },
      className: c("text-sm px-1 py-px mb-1 flex flex-row justify-between items-center text-gray-600 hover:text-gray-800 cursor-pointer", {
        "bg-white rounded text-pink-700 hover:text-pink-700": (null == s ? void 0 : s.type) === exports.types.PlaygroundSelectedItemType.Page && (null == s ? void 0 : s.name) === e.name
      })
    }, t.createElement("div", {
      className: "flex flex-row justify-start items-center flex-1"
    }, t.createElement("div", {
      className: c("mr-2", "text-gray-400", {
        "text-pink-300": (null == s ? void 0 : s.type) === exports.types.PlaygroundSelectedItemType.Page && (null == s ? void 0 : s.name) === e.name
      })
    }, t.createElement(m.FiFile, null)), t.createElement("div", null, (r = e.name).charAt(0).toUpperCase() + r.slice(1).toLowerCase())));
    var r;
  }))))));
},
    it = function it(e) {
  var r = e.page,
      n = t.useContext(k),
      o = n.setPreviewMode,
      a = n.sidebarCollapsed,
      i = n.setSidebarCollapsed;
  return n.previewMode ? t.createElement("div", {
    className: "fixed z-20 py-1 flex flex-row justify-center items-center",
    style: {
      top: 40,
      left: 0,
      right: 0
    }
  }, t.createElement("button", {
    className: "block bg-gray-100 my-3 px-3 py-1 uppercase text-xs text-pink-500 border border-pink-500 hover:border-pink-600 hover:text-pink-600 hover:shadow-lg\n          rounded",
    onClick: function onClick() {
      return o(!1);
    }
  }, "Exit preview")) : t.createElement("div", {
    className: "fixed flex z-20",
    style: {
      top: 40,
      left: a ? 0 : 220,
      right: 24,
      transition: "all 300ms"
    }
  }, t.createElement("div", {
    className: "w-full flex flex-row justify-between items-center py-3"
  }, t.createElement("h2", {
    className: "pl-8 text-lg font-semibold text-gray-700 truncate"
  }, t.createElement("button", {
    className: "focus:outline-none align-middle text-gray-500 hover:text-gray-700 mr-1",
    onClick: function onClick() {
      i(!a);
    }
  }, t.createElement(m.FiMenu, null)), " ", t.createElement("span", {
    className: "capitalize"
  }, r.name), " ", t.createElement("small", {
    className: "text-gray-500 ml-4"
  }, "below default content")), t.createElement("div", {
    className: "flex flex-row justify-end"
  }, t.createElement("button", {
    className: "block mr-2 px-3 py-1 uppercase text-xs text-pink-500 border border-pink-500 hover:border-pink-600 hover:text-pink-600 hover:shadow-lg rounded",
    onClick: function onClick() {
      return o(!0);
    }
  }, "Preview"))));
},
    lt = require("react-query").useMutation,
    ct = require("react-query").queryCache,
    st = require("react-query").useMutation,
    ut = function ut(e) {
  var r = e.handleSave,
      n = v.useForm({
    defaultValues: e.app
  }),
      o = n.register,
      a = n.errors;
  return t.createElement("form", {
    onSubmit: (0, n.handleSubmit)(r)
  }, t.createElement("section", {
    className: "mb-8"
  }, t.createElement("h3", {
    className: "text-xs font-bold uppercase tracking-wider text-gray-600 mb-1"
  }, "App Name"), t.createElement("input", {
    className: "w-full h-10 px-3 border border-grey-300 rounded focus:outline-none focus:border-pink-400",
    type: "text",
    name: "appName",
    ref: o({
      required: !0
    })
  }), a.appName && t.createElement("span", null, "The App Name is required")), t.createElement("section", {
    className: "mb-8"
  }, t.createElement("h3", {
    className: "text-xs font-bold uppercase tracking-wider text-gray-600 mb-1"
  }, "Build Webhook URL ", t.createElement("span", {
    className: "font-normal text-sm tracking-normal lowercase text-gray-500 ml-2"
  }, "(leave empty if none)")), t.createElement("input", {
    type: "text",
    className: "w-full h-10 px-3 border border-grey-300 rounded  focus:outline-none focus:border-pink-400",
    name: "deployHookUrl",
    ref: o({
      pattern: /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i
    })
  }), a.deployHookUrl && t.createElement("span", null, "This Deploy URL is not valid")), t.createElement("section", {
    className: "mb-8"
  }, t.createElement("h3", {
    className: "text-xs font-bold uppercase tracking-wider text-gray-600 mb-1"
  }, "Build Webhook HTTP Method"), t.createElement("div", {
    className: "relative"
  }, t.createElement("select", {
    className: "block w-full bg-white appearance-none border border-gray-300 h-10 px-3 pr-8 rounded focus:outline-none focus:border-pink-400",
    name: "deployHookMethod",
    ref: o
  }, t.createElement("option", {
    value: "POST"
  }, "POST"), t.createElement("option", {
    value: "GET"
  }, "GET")), t.createElement("div", {
    className: "pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
  }, t.createElement("svg", {
    className: "fill-current h-4 w-4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, t.createElement("path", {
    d: "M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
  }))))), t.createElement("button", {
    type: "submit",
    className: "bg-pink-500 hover:bg-pink-700 text-white text-sm font-semibold py-2 px-4 rounded mb-8"
  }, "Save settings"));
},
    dt = require("react-query").useQuery,
    pt = require("react-query").useQuery,
    mt = function mt(e) {
  return p.serialize(e);
};

exports.Plain = p, Object.defineProperty(exports, "uuid", {
  enumerable: !0,
  get: function get() {
    return f.v4;
  }
}), exports.Admin = function (e) {
  var r = e.children,
      n = e.isLogin,
      o = void 0 !== n && n,
      a = t.useState(""),
      i = a[0],
      l = a[1],
      c = t.useState(!1),
      s = c[0],
      u = c[1],
      d = t.useState(!1),
      p = d[0],
      m = d[1],
      g = t.useState({
    email: "",
    firstName: "",
    lastName: "",
    token: "",
    isAdmin: !1,
    appName: "",
    deployHookUrl: "",
    deployHookMethod: "POST"
  }),
      f = g[0],
      b = g[1],
      y = pe("session", function () {
    return ae(re + "/session", {
      headers: {
        Authorization: "Bearer " + localStorage.getItem(ne)
      }
    });
  }, {
    refetchOnWindowFocus: !1
  }),
      h = y.data,
      x = y.error;
  return t.useEffect(function () {
    h && h.user ? b(w({}, h.user, {
      token: h.authToken
    })) : (h && h.error || x) && b(null);

    var e = function (e) {
      if ("undefined" == typeof window) return null;
      e = e.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      var t = new RegExp("[\\?&]" + e + "=([^&#]*)").exec(window.location.search);
      return null === t ? "" : decodeURIComponent(t[1].replace(/\+/g, " "));
    }("p");

    e && l(e);
  }, [h, x]), t.createElement(xe, {
    id: "rb-admin-frame",
    style: {
      width: "100%",
      height: "100vh",
      border: "none"
    },
    head: t.createElement("style", {
      dangerouslySetInnerHTML: {
        __html: "/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}main{display:block}h1{font-size:2em;margin:.67em 0}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent}abbr[title]{border-bottom:none;text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details{display:block}summary{display:list-item}[hidden],template{display:none}blockquote,dd,dl,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}button{background-color:transparent;background-image:none;padding:0}button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}fieldset,ol,ul{margin:0;padding:0}ol,ul{list-style:none}html{font-family:system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;line-height:1.5}*,:after,:before{box-sizing:border-box;border:0 solid #e2e8f0}hr{border-top-width:1px}img{border-style:solid}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{color:#a0aec0}input:-ms-input-placeholder,textarea:-ms-input-placeholder{color:#a0aec0}input::-ms-input-placeholder,textarea::-ms-input-placeholder{color:#a0aec0}input::placeholder,textarea::placeholder{color:#a0aec0}[role=button],button{cursor:pointer}table{border-collapse:collapse}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}button,input,optgroup,select,textarea{padding:0;line-height:inherit;color:inherit}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}.container{width:100%}@media (min-width:640px){.container{max-width:640px}}@media (min-width:768px){.container{max-width:768px}}@media (min-width:1024px){.container{max-width:1024px}}@media (min-width:1280px){.container{max-width:1280px}}.appearance-none{-webkit-appearance:none;-moz-appearance:none;appearance:none}.bg-white{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.bg-gray-100{--bg-opacity:1;background-color:#f7fafc;background-color:rgba(247,250,252,var(--bg-opacity))}.bg-gray-200{--bg-opacity:1;background-color:#edf2f7;background-color:rgba(237,242,247,var(--bg-opacity))}.bg-gray-300{--bg-opacity:1;background-color:#e2e8f0;background-color:rgba(226,232,240,var(--bg-opacity))}.bg-gray-500{--bg-opacity:1;background-color:#a0aec0;background-color:rgba(160,174,192,var(--bg-opacity))}.bg-yellow-300{--bg-opacity:1;background-color:#faf089;background-color:rgba(250,240,137,var(--bg-opacity))}.bg-blue-200{--bg-opacity:1;background-color:#bee3f8;background-color:rgba(190,227,248,var(--bg-opacity))}.bg-pink-100{--bg-opacity:1;background-color:#fff5f7;background-color:rgba(255,245,247,var(--bg-opacity))}.bg-pink-200{--bg-opacity:1;background-color:#ffd6e0;background-color:rgba(255,214,224,var(--bg-opacity))}.bg-pink-500{--bg-opacity:1;background-color:#f65a8e;background-color:rgba(246,90,142,var(--bg-opacity))}.hover\\:bg-pink-100:hover{--bg-opacity:1;background-color:#fff5f7;background-color:rgba(255,245,247,var(--bg-opacity))}.hover\\:bg-pink-600:hover{--bg-opacity:1;background-color:#d9367f;background-color:rgba(217,54,127,var(--bg-opacity))}.hover\\:bg-pink-700:hover{--bg-opacity:1;background-color:#b43179;background-color:rgba(180,49,121,var(--bg-opacity))}.focus\\:bg-white:focus{--bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--bg-opacity))}.border-transparent{border-color:transparent}.border-gray-200{--border-opacity:1;border-color:#edf2f7;border-color:rgba(237,242,247,var(--border-opacity))}.border-gray-300{--border-opacity:1;border-color:#e2e8f0;border-color:rgba(226,232,240,var(--border-opacity))}.border-gray-400{--border-opacity:1;border-color:#cbd5e0;border-color:rgba(203,213,224,var(--border-opacity))}.border-gray-500{--border-opacity:1;border-color:#a0aec0;border-color:rgba(160,174,192,var(--border-opacity))}.border-red-500{--border-opacity:1;border-color:#f56565;border-color:rgba(245,101,101,var(--border-opacity))}.border-blue-300{--border-opacity:1;border-color:#90cdf4;border-color:rgba(144,205,244,var(--border-opacity))}.border-pink-400{--border-opacity:1;border-color:#fb83a3;border-color:rgba(251,131,163,var(--border-opacity))}.border-pink-500{--border-opacity:1;border-color:#f65a8e;border-color:rgba(246,90,142,var(--border-opacity))}.hover\\:border-pink-400:hover{--border-opacity:1;border-color:#fb83a3;border-color:rgba(251,131,163,var(--border-opacity))}.hover\\:border-pink-600:hover{--border-opacity:1;border-color:#d9367f;border-color:rgba(217,54,127,var(--border-opacity))}.focus\\:border-gray-500:focus{--border-opacity:1;border-color:#a0aec0;border-color:rgba(160,174,192,var(--border-opacity))}.focus\\:border-pink-400:focus{--border-opacity:1;border-color:#fb83a3;border-color:rgba(251,131,163,var(--border-opacity))}.rounded-sm{border-radius:.125rem}.rounded{border-radius:.25rem}.rounded-lg{border-radius:.5rem}.rounded-full{border-radius:9999px}.rounded-r-lg{border-top-right-radius:.5rem;border-bottom-right-radius:.5rem}.border-2{border-width:2px}.border{border-width:1px}.border-b-4{border-bottom-width:4px}.border-b{border-bottom-width:1px}.cursor-pointer{cursor:pointer}.disabled\\:cursor-not-allowed:disabled{cursor:not-allowed}.block{display:block}.inline-block{display:inline-block}.inline{display:inline}.flex{display:flex}.hidden{display:none}.flex-row{flex-direction:row}.flex-col{flex-direction:column}.flex-wrap{flex-wrap:wrap}.items-center{align-items:center}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.justify-around{justify-content:space-around}.flex-1{flex:1 1 0%}.flex-grow{flex-grow:1}.font-thin{font-weight:200}.font-normal{font-weight:400}.font-semibold{font-weight:600}.font-bold{font-weight:700}.h-4{height:1rem}.h-6{height:1.5rem}.h-8{height:2rem}.h-10{height:2.5rem}.h-20{height:5rem}.h-full{height:100%}.h-screen{height:100vh}.text-xs{font-size:.75rem}.text-sm{font-size:.875rem}.text-lg{font-size:1.125rem}.text-4xl{font-size:2.25rem}.text-5xl{font-size:3rem}.leading-none{line-height:1}.leading-tight{line-height:1.25}.my-3{margin-top:.75rem;margin-bottom:.75rem}.my-6{margin-top:1.5rem;margin-bottom:1.5rem}.mx-auto{margin-left:auto;margin-right:auto}.mt-1{margin-top:.25rem}.mr-1{margin-right:.25rem}.mb-1{margin-bottom:.25rem}.ml-1{margin-left:.25rem}.mt-2{margin-top:.5rem}.mr-2{margin-right:.5rem}.mb-2{margin-bottom:.5rem}.ml-2{margin-left:.5rem}.mb-3{margin-bottom:.75rem}.mt-4{margin-top:1rem}.mb-4{margin-bottom:1rem}.ml-4{margin-left:1rem}.mb-5{margin-bottom:1.25rem}.mb-6{margin-bottom:1.5rem}.mt-8{margin-top:2rem}.mb-8{margin-bottom:2rem}.mb-12{margin-bottom:3rem}.mt-20{margin-top:5rem}.-ml-1{margin-left:-.25rem}.max-w-xl{max-width:36rem}.max-w-3xl{max-width:48rem}.object-cover{-o-object-fit:cover;object-fit:cover}.disabled\\:opacity-75:disabled{opacity:.75}.focus\\:outline-none:focus,.outline-none{outline:0}.overflow-y-auto{overflow-y:auto}.scrolling-touch{-webkit-overflow-scrolling:touch}.p-4{padding:1rem}.py-1{padding-top:.25rem;padding-bottom:.25rem}.px-1{padding-left:.25rem;padding-right:.25rem}.py-2{padding-top:.5rem;padding-bottom:.5rem}.px-2{padding-left:.5rem;padding-right:.5rem}.py-3{padding-top:.75rem;padding-bottom:.75rem}.px-3{padding-left:.75rem;padding-right:.75rem}.px-4{padding-left:1rem;padding-right:1rem}.py-6{padding-top:1.5rem;padding-bottom:1.5rem}.px-6{padding-left:1.5rem;padding-right:1.5rem}.px-12{padding-left:3rem;padding-right:3rem}.py-16{padding-top:4rem;padding-bottom:4rem}.px-20{padding-left:5rem;padding-right:5rem}.py-px{padding-top:1px;padding-bottom:1px}.pb-1{padding-bottom:.25rem}.pr-4{padding-right:1rem}.pb-4{padding-bottom:1rem}.pl-4{padding-left:1rem}.pr-5{padding-right:1.25rem}.pl-6{padding-left:1.5rem}.pr-8{padding-right:2rem}.pl-8{padding-left:2rem}.pt-10{padding-top:2.5rem}.pt-12{padding-top:3rem}.pr-12{padding-right:3rem}.pb-12{padding-bottom:3rem}.pt-24{padding-top:6rem}.pb-24{padding-bottom:6rem}.pointer-events-none{pointer-events:none}.static{position:static}.fixed{position:fixed}.absolute{position:absolute}.relative{position:relative}.inset-y-0{top:0;bottom:0}.inset-x-0{right:0;left:0}.top-0{top:0}.right-0{right:0}.bottom-0{bottom:0}.left-0{left:0}.shadow{box-shadow:0 1px 3px 0 rgba(0,0,0,.1),0 1px 2px 0 rgba(0,0,0,.06)}.hover\\:shadow-lg:hover,.shadow-lg{box-shadow:0 10px 15px -3px rgba(0,0,0,.1),0 4px 6px -2px rgba(0,0,0,.05)}.fill-current{fill:currentColor}.text-center{text-align:center}.text-white{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.text-gray-400{--text-opacity:1;color:#cbd5e0;color:rgba(203,213,224,var(--text-opacity))}.text-gray-500{--text-opacity:1;color:#a0aec0;color:rgba(160,174,192,var(--text-opacity))}.text-gray-600{--text-opacity:1;color:#718096;color:rgba(113,128,150,var(--text-opacity))}.text-gray-700{--text-opacity:1;color:#4a5568;color:rgba(74,85,104,var(--text-opacity))}.text-gray-800{--text-opacity:1;color:#2d3748;color:rgba(45,55,72,var(--text-opacity))}.text-gray-900{--text-opacity:1;color:#1a202c;color:rgba(26,32,44,var(--text-opacity))}.text-green-500{--text-opacity:1;color:#48bb78;color:rgba(72,187,120,var(--text-opacity))}.text-red-400{--text-opacity:1;color:#fc8181;color:rgba(252,129,129,var(--text-opacity))}.text-red-500{--text-opacity:1;color:#f56565;color:rgba(245,101,101,var(--text-opacity))}.text-blue-400{--text-opacity:1;color:#63b3ed;color:rgba(99,179,237,var(--text-opacity))}.text-blue-800{--text-opacity:1;color:#2c5282;color:rgba(44,82,130,var(--text-opacity))}.text-pink-300{--text-opacity:1;color:#fdb4c6;color:rgba(253,180,198,var(--text-opacity))}.text-pink-400{--text-opacity:1;color:#fb83a3;color:rgba(251,131,163,var(--text-opacity))}.text-pink-500{--text-opacity:1;color:#f65a8e;color:rgba(246,90,142,var(--text-opacity))}.text-pink-600{--text-opacity:1;color:#d9367f;color:rgba(217,54,127,var(--text-opacity))}.text-pink-700{--text-opacity:1;color:#b43179;color:rgba(180,49,121,var(--text-opacity))}.hover\\:text-white:hover{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity))}.hover\\:text-gray-500:hover{--text-opacity:1;color:#a0aec0;color:rgba(160,174,192,var(--text-opacity))}.hover\\:text-gray-700:hover{--text-opacity:1;color:#4a5568;color:rgba(74,85,104,var(--text-opacity))}.hover\\:text-gray-800:hover{--text-opacity:1;color:#2d3748;color:rgba(45,55,72,var(--text-opacity))}.hover\\:text-gray-900:hover{--text-opacity:1;color:#1a202c;color:rgba(26,32,44,var(--text-opacity))}.hover\\:text-green-600:hover{--text-opacity:1;color:#38a169;color:rgba(56,161,105,var(--text-opacity))}.hover\\:text-red-500:hover{--text-opacity:1;color:#f56565;color:rgba(245,101,101,var(--text-opacity))}.hover\\:text-pink-600:hover{--text-opacity:1;color:#d9367f;color:rgba(217,54,127,var(--text-opacity))}.hover\\:text-pink-700:hover{--text-opacity:1;color:#b43179;color:rgba(180,49,121,var(--text-opacity))}.focus\\:text-gray-800:focus{--text-opacity:1;color:#2d3748;color:rgba(45,55,72,var(--text-opacity))}.italic{font-style:italic}.uppercase{text-transform:uppercase}.lowercase{text-transform:lowercase}.capitalize{text-transform:capitalize}.no-underline{text-decoration:none}.hover\\:underline:hover{text-decoration:underline}.tracking-normal{letter-spacing:0}.tracking-wide{letter-spacing:.025em}.tracking-wider{letter-spacing:.05em}.align-middle{vertical-align:middle}.truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.w-0{width:0}.w-4{width:1rem}.w-8{width:2rem}.w-24{width:6rem}.w-48{width:12rem}.w-56{width:14rem}.w-64{width:16rem}.w-3\\/4{width:75%}.w-full{width:100%}.z-10{z-index:10}.z-20{z-index:20}.z-50{z-index:50}.transform{--transform-translate-x:0;--transform-translate-y:0;--transform-rotate:0;--transform-skew-x:0;--transform-skew-y:0;--transform-scale-x:1;--transform-scale-y:1;transform:translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y))}.transition{transition-property:background-color,border-color,color,fill,stroke,opacity,box-shadow,transform}body{background-color:#f7fafc}@media (min-width:640px){.sm\\:mx-0{margin-left:0;margin-right:0}.sm\\:px-0{padding-left:0;padding-right:0}.sm\\:w-3\\/4{width:75%}}@media (min-width:768px){.md\\:block{display:block}.md\\:w-1\\/2{width:50%}}@media (min-width:1024px){.lg\\:w-1\\/2{width:50%}}"
      }
    })
  }, t.createElement(k.Provider, {
    value: {
      isAdmin: !0,
      user: f,
      setUser: b,
      currentPage: i,
      setCurrentPage: l,
      previewMode: s,
      setPreviewMode: u,
      sidebarCollapsed: p,
      setSidebarCollapsed: m,
      getStyles: function getStyles() {
        return document.querySelectorAll("style");
      },
      getStylesheets: function getStylesheets() {
        return document.querySelectorAll("link[rel=stylesheet]");
      }
    }
  }, t.createElement(he, {
    isLogin: o
  }), t.createElement(ye, null), r));
}, exports.AdminContext = k, exports.AppSettings = function () {
  var e = t.useContext(k).user,
      r = t.useContext(_).appId,
      n = lt(function (e) {
    var t = {
      appName: e.appName,
      deployHookUrl: e.deployHookUrl,
      deployHookMethod: e.deployHookMethod
    };
    return ae(re + "/apps/" + e.appId, {
      method: "PUT",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(ne),
        "Content-Type": "application/json"
      },
      body: JSON.stringify(t)
    });
  }, {
    onSuccess: function onSuccess(e) {
      ct.refetchQueries("session"), 423 === e.statusCode ? s.warn("Saving not allowed on this demo", {
        position: "bottom-right"
      }) : e.statusCode ? s.error("An error occurred while saving the app settings", {
        position: "bottom-right"
      }) : s.success("App settings saved", {
        position: "bottom-right"
      });
    },
    onError: function onError() {
      s.error("An error occurred while saving the app settings", {
        position: "bottom-right"
      });
    }
  })[0],
      o = st(function () {
    return ae(re + "/deploy", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(ne),
        "Content-Type": "application/json"
      }
    });
  }, {
    onSuccess: function onSuccess(e) {
      423 === e.statusCode ? s.warn("Deploy not allowed on this demo", {
        position: "bottom-right"
      }) : e.statusCode ? s.error("An error occurred while requesting the rebuild", {
        position: "bottom-right"
      }) : "OK" === e.result ? s.success("Rebuild requested. The website content will be updated soon", {
        position: "bottom-right"
      }) : s.warn("The webhook returned an error: " + e.message, {
        position: "bottom-right"
      });
    },
    onError: function onError() {
      s.error("An error occurred while requesting the rebuild", {
        position: "bottom-right"
      });
    }
  })[0],
      a = {
    appName: (null == e ? void 0 : e.appName) || "",
    deployHookMethod: (null == e ? void 0 : e.deployHookMethod) || "POST",
    deployHookUrl: (null == e ? void 0 : e.deployHookUrl) || ""
  };
  return t.createElement("div", {
    className: "mt-20 py-16 px-20 max-w-3xl bg-white mx-auto"
  }, t.createElement("h2", {
    className: "text-lg font-semibold text-gray-700 mb-3"
  }, (null == e ? void 0 : e.isAdmin) ? "App Settings" : "Deploy content"), (null == e ? void 0 : e.isAdmin) ? t.createElement("p", {
    className: "mb-8 text-gray-600"
  }, "Here you can set the App name and the deploy configuration, so that the editor user may trigger a re-build on your static hosting platform via webhooks.") : t.createElement("p", {
    className: "mb-8 text-gray-500"
  }, "Here you can trigger a deploy of the content on the live website."), (null == e ? void 0 : e.isAdmin) && t.createElement(ut, {
    app: a,
    handleSave: function handleSave(e) {
      n(w({
        appId: r
      }, e));
    }
  }), (null == e ? void 0 : e.deployHookUrl) ? t.createElement("button", {
    type: "button",
    onClick: function onClick() {
      o();
    },
    className: "bg-pink-500 hover:bg-pink-700 text-white text-sm font-semibold py-2 px-4 rounded"
  }, "Deploy now") : t.createElement(t.Fragment, null, t.createElement("p", null, "The deploy button is not available."), t.createElement("p", null, "No static export deploy has been chosen or the deploy hook has not been provided.")));
}, exports.Editor = function () {
  return t.createElement("div", {
    className: "w-full pt-10 mx-auto px-6 flex justify-between"
  }, t.createElement(Ce, null), t.createElement(et, null));
}, exports.Header = be, exports.Image = ce, exports.Link = K, exports.Login = function () {
  var e = t.useContext(_),
      r = e.navigate,
      n = e.editorPath,
      o = t.useState(""),
      a = o[0],
      i = o[1],
      l = t.useState(""),
      c = l[0],
      s = l[1],
      u = t.useState(""),
      d = u[0],
      p = u[1],
      m = ge().loginUser;
  return t.createElement("div", {
    className: "flex flex-col h-screen justify-center items-center px-4 sm:px-0"
  }, t.createElement("div", {
    className: "flex bg-white rounded shadow-lg w-full sm:w-3/4 lg:w-1/2 sm:mx-0",
    style: {
      height: 500
    }
  }, t.createElement("div", {
    className: "flex flex-col w-full md:w-1/2 p-4"
  }, t.createElement("div", {
    className: "flex flex-col flex-1 justify-center mb-8"
  }, t.createElement("h1", {
    className: "text-4xl text-center font-thin"
  }, "Welcome"), t.createElement("div", {
    className: "w-full mt-4"
  }, t.createElement("form", {
    onSubmit: function onSubmit(e) {
      e.preventDefault(), m(a, c).then(function () {
        return r(n);
      }, function (e) {
        p(e);
      });
    },
    className: "form-horizontal w-3/4 mx-auto"
  }, t.createElement("div", {
    className: "flex flex-col mt-4"
  }, t.createElement("input", {
    id: "email",
    type: "text",
    value: a,
    onChange: function onChange(e) {
      return i(e.target.value);
    },
    className: "flex-grow h-8 px-2 border rounded border-grey-400",
    name: "email",
    placeholder: "Email"
  })), t.createElement("div", {
    className: "flex flex-col mt-4"
  }, t.createElement("input", {
    id: "password",
    type: "password",
    value: c,
    onChange: function onChange(e) {
      return s(e.target.value);
    },
    className: "flex-grow h-8 px-2 rounded border border-grey-400",
    name: "password",
    required: !0,
    placeholder: "Password"
  })), t.createElement("div", {
    className: "flex flex-col mt-8"
  }, t.createElement("button", {
    type: "submit",
    className: "bg-pink-500 hover:bg-pink-700 text-white text-sm font-semibold py-2 px-4 rounded"
  }, "Login"), d && t.createElement("div", {
    className: "text-red-400"
  }, "Auth failed"))), t.createElement("div", {
    className: "text-center mt-4"
  }, t.createElement("a", {
    className: "no-underline hover:underline text-blue-dark text-xs",
    href: "#"
  }, "Forgot Your Password?"))))), t.createElement("div", {
    className: "hidden md:block md:w-1/2 rounded-r-lg",
    style: {
      backgroundImage: "url(https://images.unsplash.com/photo-1461418559055-6f020c5a91e7?ixlib=rb-1.2.1&auto=format&fit=crop&w=1601&q=80)",
      backgroundSize: "cover",
      backgroundPosition: "center center"
    }
  })));
}, exports.PageViewer = function (e) {
  var r = e.page,
      n = t.useContext(_);
  return t.createElement("div", null, r && r.content && r.content.length > 0 && t.createElement(t.Fragment, null, t.createElement(rt, {
    schema: n.blockTypeSchema,
    content: r.content
  }), t.createElement(nt, {
    pageId: r.id
  })));
}, exports.Playground = function () {
  var e = t.useState(null),
      r = e[0],
      n = e[1],
      o = t.useContext(_),
      a = o.blockTypeSchema,
      i = o.pageTypeSchema,
      l = t.useContext(k).setCurrentPage,
      c = t.useState([]),
      s = c[0],
      u = c[1],
      d = t.useState(Le),
      p = d[0],
      m = d[1];
  return t.useEffect(function () {
    if (r) {
      var e = "playground_" + f.v4();

      if (r.type === exports.types.PlaygroundSelectedItemType.Block) {
        var t = a.find(function (e) {
          return e.name === r.name;
        });

        if (t) {
          var n = {
            id: f.v4(),
            type: r.name,
            props: t.getDefaultProps()
          };
          u([n]), m(w({}, p, {
            id: e,
            name: r.label,
            slug: r.name
          })), l(e);
        }
      } else {
        var o = i.find(function (e) {
          return e.name === r.name;
        });
        o && (u(o.getDefaultContent ? Pe(a, o.getDefaultContent(), o.allowedBlockTypes, o.excludedBlockTypes).blocks : []), m(w({}, p, {
          id: e,
          name: r.label,
          slug: r.name
        })), l(e));
      }
    }
  }, [r]), t.createElement(ot.Provider, {
    value: {
      selectedItem: r,
      setSelectedItem: n
    }
  }, t.createElement("div", {
    className: "w-full pt-10 mx-auto px-6 flex justify-between"
  }, t.createElement(at, null), r ? t.createElement("div", {
    className: "flex-1"
  }, t.createElement(it, {
    page: p
  }), t.createElement(Ze, {
    page: p,
    content: s,
    onChange: u,
    locked: !0,
    playgroundSelectedItem: r
  })) : t.createElement("div", {
    className: "flex-1 flex flex-col justify-start"
  }, t.createElement("div", {
    className: "flex flex-row justify-start pt-12 pr-12"
  }, t.createElement("div", {
    className: "flex-1"
  }, t.createElement("h1", {
    className: "text-5xl px-12 pb-12"
  }, t.createElement("span", {
    className: "text-pink-500"
  }, "Play"), t.createElement("span", {
    className: "text-gray-700"
  }, "ground")), t.createElement("p", {
    className: "px-12"
  }, "Here you can test your ", t.createElement("b", null, "Block type"), " schema and your", " ", t.createElement("b", null, "Page type"), " schema."))))));
}, exports.ReactBricks = function (e) {
  var r = e.appId,
      n = e.apiKey,
      o = e.blockTypeSchema,
      a = e.pageTypeSchema,
      i = e.logo,
      l = void 0 === i ? "" : i,
      c = e.contentClassName,
      s = void 0 === c ? "" : c,
      u = e.renderLocalLink,
      p = e.navigate,
      m = e.loginPath,
      g = void 0 === m ? "/admin" : m,
      f = e.editorPath,
      b = void 0 === f ? "/admin/editor" : f,
      y = e.playgroundPath,
      h = void 0 === y ? "/admin/playground" : y,
      x = e.appSettingsPath,
      v = void 0 === x ? "/admin/app-settings" : x,
      k = e.children;
  return d.KeyUtils.resetGenerator(), o || console.warn("No Block type schema provided. Using default paragraph."), a || console.warn("No Page type schema provided. Using default page."), t.createElement(_.Provider, {
    value: {
      appId: r,
      apiKey: n,
      blockTypeSchema: o || ue,
      pageTypeSchema: a || de,
      logo: l,
      contentClassName: s,
      renderLocalLink: u,
      navigate: p,
      loginPath: g,
      editorPath: b,
      playgroundPath: h,
      appSettingsPath: v
    }
  }, k);
}, exports.ReactBricksContext = _, exports.RichText = te, exports.Text = function (e) {
  var r = e.renderBlock,
      o = e.value,
      a = e.placeholder,
      i = e.propName,
      l = e.onChange,
      c = t.useContext(k),
      s = c.previewMode || !c.isAdmin;
  return s ? t.createElement(t.Fragment, null, o.document.nodes.map(function (e, n) {
    return t.createElement("div", {
      key: n
    }, (null == e ? void 0 : e.text) && r({
      children: e.text
    }));
  })) : t.createElement(n.Editor, {
    readOnly: s,
    placeholder: a,
    value: o,
    onChange: function onChange(e) {
      l(i, e.value);
    },
    renderBlock: r,
    schema: E
  });
}, exports.cleanPage = Ie, exports.fetchPage = function (e, t) {
  try {
    return Promise.resolve(ae(oe + "/pages/" + e, {
      headers: {
        Authorization: "Bearer " + t
      }
    }));
  } catch (e) {
    return Promise.reject(e);
  }
}, exports.fetchPages = function (e, t) {
  var r = void 0 === t ? {} : t,
      n = r.type,
      o = r.tag;

  try {
    return Promise.resolve(ae(oe + "/pages?type=" + (n || "") + "&tag=" + (o || ""), {
      headers: {
        Authorization: "Bearer " + e
      }
    }));
  } catch (e) {
    return Promise.reject(e);
  }
}, exports.getPagePlainText = function e(t) {
  return t.reduce(function (t, r) {
    var n = [];

    for (var o in r.props) {
      r.props[o] instanceof d.Value && n.push(mt(r.props[o])), "items" === o && n.push.apply(n, e(r.props[o]));
    }

    return [].concat(t, n);
  }, []);
}, exports.getPlainText = mt, exports.useAuth = ge, exports.usePage = Se, exports.usePagePublic = function (e) {
  var r = t.useContext(_).apiKey;
  return dt(e && ["pagePublic", {
    slug: e
  }], function () {
    return ae(oe + "/pages/" + e, {
      headers: {
        Authorization: "Bearer " + r
      }
    });
  }, {
    refetchOnWindowFocus: !1
  });
}, exports.usePages = ke, exports.usePagesPublic = function (e) {
  var r = void 0 === e ? {} : e,
      n = r.type,
      o = r.tag,
      a = t.useContext(_).apiKey;
  return pt(["pagesPublic", {
    type: n,
    tag: o
  }], function () {
    return ae(oe + "/pages?type=" + (n || "") + "&tag=" + (o || ""), {
      headers: {
        Authorization: "Bearer " + a
      }
    });
  });
};